window.slate = window.slate || {};
window.theme = window.theme || {};

if ((typeof Shopify) === 'undefined') {window.Shopify = {};}
  // Get from cart.js returns the cart in JSON
  if ((typeof Shopify.getCart) === 'undefined') {
  Shopify.getCart = function(callback, cart) {
    if(!cart) {
    return jQuery.getJSON('/cart.js', function (cart, textStatus, xhr) {
        if ((typeof callback) === 'function') {
        callback(cart,textStatus, xhr);
      }
      else {
        Shopify.onCartUpdate(cart);
          }
      });
    } else {
      if ((typeof callback) === 'function') {
      callback(cart);
    } else if(typeof Shopify.onCartUpdate ==='function') {
      Shopify.onCartUpdate(cart);
        }
    }
  };
}

/*================ Slate ================*/
/**
 * A11y Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help make your theme more accessible
 * to users with visual impairments.
 *
 *
 * @namespace a11y
 */

slate.a11y = {

    /**
     * For use when focus shifts to a container rather than a link
     * eg for In-page links, after scroll, focus shifts to content area so that
     * next `tab` is where user expects if focusing a link, just $link.focus();
     *
     * @param {JQuery} $element - The element to be acted upon
     */
    pageLinkFocus: function ($element) {
        var focusClass = 'js-focus-hidden';

        $element.first()
            .attr('tabIndex', '-1')
            .focus()
            .addClass(focusClass)
            .one('blur', callback);

        function callback() {
            $element.first()
                .removeClass(focusClass)
                .removeAttr('tabindex');
        }
    },

    /**
     * If there's a hash in the url, focus the appropriate element
     */
    focusHash: function () {
        var hash = window.location.hash;

        // is there a hash in the url? is it an element on the page?
        if (hash && document.getElementById(hash.slice(1))) {
            this.pageLinkFocus($(hash));
        }
    },

    /**
     * When an in-page (url w/hash) link is clicked, focus the appropriate element
     */
    bindInPageLinks: function () {
        $('a[href*=#]').on('click', function (evt) {
            this.pageLinkFocus($(evt.currentTarget.hash));
        }.bind(this));
    },

    /**
     * Traps the focus in a particular container
     *
     * @param {object} options - Options to be used
     * @param {jQuery} options.$container - Container to trap focus within
     * @param {jQuery} options.$elementToFocus - Element to be focused when focus leaves container
     * @param {string} options.namespace - Namespace used for new focus event handler
     */
    trapFocus: function (options) {
        var eventName = options.namespace
            ? 'focusin.' + options.namespace
            : 'focusin';

        if (!options.$elementToFocus) {
            options.$elementToFocus = options.$container;
        }

        options.$container.attr('tabindex', '-1');
        options.$elementToFocus.focus();

        $(document).on(eventName, function (evt) {
            if (options.$container[0] !== evt.target && !options.$container.has(evt.target).length) {
                options.$container.focus();
            }
        });
    },

    /**
     * Removes the trap of focus in a particular container
     *
     * @param {object} options - Options to be used
     * @param {jQuery} options.$container - Container to trap focus within
     * @param {string} options.namespace - Namespace used for new focus event handler
     */
    removeTrapFocus: function (options) {
        var eventName = options.namespace
            ? 'focusin.' + options.namespace
            : 'focusin';

        if (options.$container && options.$container.length) {
            options.$container.removeAttr('tabindex');
        }

        $(document).off(eventName);
    }
};

/**
 * Announcement banner slider
 */
var announcementSlider = document.querySelector('#AnnouncementSlider');
if (announcementSlider) {
// Initialise Slick
$('#AnnouncementSlider').slick({
    slidesToShow: 1,
    dots: false,
    arrows: false,
    adaptiveHeight: true,
    autoplay: true,
    autoplaySpeed: 2450,
  });
}

/**
 * Cart Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Cart template.
 *
 * @namespace cart
 */

slate.cart = {

    /**
     * Browser cookies are required to use the cart. This function checks if
     * cookies are enabled in the browser.
     */
    cookiesEnabled: function () {
        var cookieEnabled = navigator.cookieEnabled;

        if (!cookieEnabled) {
            document.cookie = 'testcookie';
            cookieEnabled = (document.cookie.indexOf('testcookie') !== -1);
        }
        return cookieEnabled;
    }
};

/**
 * Utility helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions for dealing with arrays and objects
 *
 * @namespace utils
 */

slate.utils = {

    /**
     * Return an object from an array of objects that matches the provided key and value
     *
     * @param {array} array - Array of objects
     * @param {string} key - Key to match the value against
     * @param {string} value - Value to get match of
     */
    findInstance: function (array, key, value) {
        for (var i = 0; i < array.length; i++) {
            if (array[i][key] === value) {
                return array[i];
            }
        }
    },

    /**
     * Remove an object from an array of objects by matching the provided key and value
     *
     * @param {array} array - Array of objects
     * @param {string} key - Key to match the value against
     * @param {string} value - Value to get match of
     */
    removeInstance: function (array, key, value) {
        var i = array.length;
        while (i--) {
            if (array[i][key] === value) {
                array.splice(i, 1);
                break;
            }
        }

        return array;
    },

    /**
     * _.compact from lodash
     * Remove empty/false items from array
     * Source: https://github.com/lodash/lodash/blob/master/compact.js
     *
     * @param {array} array
     */
    compact: function (array) {
        var index = -1;
        var length = array == null ? 0 : array.length;
        var resIndex = 0;
        var result = [];

        while (++index < length) {
            var value = array[index];
            if (value) {
                result[resIndex++] = value;
            }
        }
        return result;
    },

    /**
     * _.defaultTo from lodash
     * Checks `value` to determine whether a default value should be returned in
     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
     * or `undefined`.
     * Source: https://github.com/lodash/lodash/blob/master/defaultTo.js
     *
     * @param {*} value - Value to check
     * @param {*} defaultValue - Default value
     * @returns {*} - Returns the resolved value
     */
    defaultTo: function (value, defaultValue) {
        return (value == null || value !== value) ? defaultValue : value
    },

    tConvert (time) {
      // Check correct time format and split into components
      time = time.toString ().match (/^([01]\d|2[0-3])(:)([0-5]\d)(:[0-5]\d)?$/) || [time];

      if (time.length > 1) { // If time format correct
        time = time.slice (1);  // Remove full string match value
        time[5] = +time[0] < 12 ? 'am' : 'pm'; // Set AM/PM
        time[0] = +time[0] % 12 || 12; // Adjust hours
      }
      return time.join (''); // return adjusted time or original string
    },

    timezones: {
        'QLD': '10:00',
        'NSW': '10:00',
        'VIC': '10:00',
        'ACT': '10:00',
        'TAS': '10:00',
        'NT': '09:30',
        'SA': '09:30',
        'WA': '08:00',
    },

    dstTimezones: {
        'QLD': '10:00',
        'NSW': '11:00',
        'VIC': '11:00',
        'ACT': '11:00',
        'TAS': '11:00',
        'NT': '09:30',
        'SA': '10:30',
        'WA': '08:00',
    },

    timezone(state) {
        var today = new Date();
        var startDst = new Date(today.getFullYear(), 9, 1);
        var endDst = new Date(today.getFullYear(), 3, 1);

        if (today >= endDst && today < startDst) {
            return slate.utils.timezones[state];
        }

        return slate.utils.dstTimezones[state];
    }
};

/**
 * Rich Text Editor
 * -----------------------------------------------------------------------------
 * Wrap videos in div to force responsive layout.
 *
 * @namespace rte
 */

slate.rte = {

    wrapTable: function () {
        $('.rte table').wrap('<div class="rte__table-wrapper"></div>');
    },

    iframeReset: function () {
        var $iframeVideo = $('.rte iframe[src*="youtube.com/embed"], .rte iframe[src*="player.vimeo"]');
        var $iframeReset = $iframeVideo.add('.rte iframe#admin_bar_iframe');

        $iframeVideo.each(function () {
            // Add wrapper to make video responsive
            $(this).wrap('<div class="rte__video-wrapper"></div>');
        });

        $iframeReset.each(function () {
            // Re-set the src attribute on each iframe after page load
            // for Chrome's "incorrect iFrame content on 'back'" bug.
            // https://code.google.com/p/chromium/issues/detail?id=395791
            // Need to specifically target video and admin bar
            this.src = this.src;
        });
    }
};

slate.Sections = function Sections() {
    this.constructors = {};
    this.instances = [];

    $(document)
        .on('shopify:section:load', this._onSectionLoad.bind(this))
        .on('shopify:section:unload', this._onSectionUnload.bind(this))
        .on('shopify:section:select', this._onSelect.bind(this))
        .on('shopify:section:deselect', this._onDeselect.bind(this))
        .on('shopify:section:reorder', this._onReorder.bind(this))
        .on('shopify:block:select', this._onBlockSelect.bind(this))
        .on('shopify:block:deselect', this._onBlockDeselect.bind(this));
};

slate.Sections.prototype = $.extend({}, slate.Sections.prototype, {
    _createInstance: function (container, constructor) {
        var $container = $(container);
        var id = $container.attr('data-section-id');
        var type = $container.attr('data-section-type');

        constructor = constructor || this.constructors[type];

        if (typeof constructor === 'undefined') {
            return;
        }

        var instance = $.extend(new constructor(container), {
            id: id,
            type: type,
            container: container
        });

        this.instances.push(instance);
    },

    _onSectionLoad: function (evt) {
        var container = $('[data-section-id]', evt.target)[0];
        if (container) {
            this._createInstance(container);
        }
    },

    _onSectionUnload: function (evt) {
        var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

        if (!instance) {
            return;
        }

        if (typeof instance.onUnload === 'function') {
            instance.onUnload(evt);
        }

        this.instances = slate.utils.removeInstance(this.instances, 'id', evt.detail.sectionId);
    },

    _onSelect: function (evt) {
        var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

        if (instance && typeof instance.onSelect === 'function') {
            instance.onSelect(evt);
        }
    },

    _onDeselect: function (evt) {
        var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

        if (instance && typeof instance.onDeselect === 'function') {
            instance.onDeselect(evt);
        }
    },

    _onReorder: function (evt) {
        var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

        if (instance && typeof instance.onReorder === 'function') {
            instance.onReorder(evt);
        }
    },

    _onBlockSelect: function (evt) {
        var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

        if (instance && typeof instance.onBlockSelect === 'function') {
            instance.onBlockSelect(evt);
        }
    },

    _onBlockDeselect: function (evt) {
        var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

        if (instance && typeof instance.onBlockDeselect === 'function') {
            instance.onBlockDeselect(evt);
        }
    },

    register: function (type, constructor) {
        this.constructors[type] = constructor;

        $('[data-section-type=' + type + ']').each(function (index, container) {
            this._createInstance(container, constructor);
        }.bind(this));
    }
});

/**
 * Currency Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help with currency formatting
 *
 * Current contents
 * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.
 *
 */

slate.Currency = (function () {
    var moneyFormat = '${{amount}}';

    /**
     * Format money values based on your shop currency settings
     * @param  {Number|string} cents - value in cents or dollar amount e.g. 300 cents
     * or 3.00 dollars
     * @param  {String} format - shop money_format setting
     * @return {String} value - formatted value
     */
    function formatMoney(cents, format) {
        if (typeof cents === 'string') {
            cents = cents.replace('.', '');
        }
        var value = '';
        var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
        var formatString = (format || moneyFormat);

        function formatWithDelimiters(number, precision, thousands, decimal) {
            precision = slate.utils.defaultTo(precision, 2);
            thousands = slate.utils.defaultTo(thousands, ',');
            decimal = slate.utils.defaultTo(decimal, '.');

            if (isNaN(number) || number == null) {
                return 0;
            }

            number = (number / 100.0).toFixed(precision);

            var parts = number.split('.');
            var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
            var centsAmount = parts[1] ? (decimal + parts[1]) : '';

            return dollarsAmount + centsAmount;
        }

        switch (formatString.match(placeholderRegex)[1]) {
            case 'amount':
                value = formatWithDelimiters(cents, 2);
                break;
            case 'amount_no_decimals':
                value = formatWithDelimiters(cents, 0);
                break;
            case 'amount_with_space_separator':
                value = formatWithDelimiters(cents, 2, ' ', '.');
                break;
            case 'amount_no_decimals_with_comma_separator':
                value = formatWithDelimiters(cents, 0, ',', '.');
                break;
            case 'amount_no_decimals_with_space_separator':
                value = formatWithDelimiters(cents, 0, ' ');
                break;
        }

        return formatString.replace(placeholderRegex, value);
    }

    return {
        formatMoney: formatMoney
    };
})();

/**
 * Image Helper Functions
 * -----------------------------------------------------------------------------
 * A collection of functions that help with basic image operations.
 *
 */

slate.Image = (function () {

    /**
     * Preloads an image in memory and uses the browsers cache to store it until needed.
     *
     * @param {Array} images - A list of image urls
     * @param {String} size - A shopify image size attribute
     */

    function preload(images, size) {
        if (typeof images === 'string') {
            images = [images];
        }

        for (var i = 0; i < images.length; i++) {
            var image = images[i];
            this.loadImage(this.getSizedImageUrl(image, size));
        }
    }

    /**
     * Loads and caches an image in the browsers cache.
     * @param {string} path - An image url
     */
    function loadImage(path) {
        new Image().src = path;
    }

    /**
     * Find the Shopify image attribute size
     *
     * @param {string} src
     * @returns {null}
     */
    function imageSize(src) {
        if (typeof src === 'undefined') {
            return null;
        }

        var match = src.match(/.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/);

        if (match) {
            return match[1];
        } else {
            return null;
        }
    }

    /**
     * Adds a Shopify size attribute to a URL
     *
     * @param src
     * @param size
     * @returns {*}
     */
    function getSizedImageUrl(src, size) {
        if (size === null) {
            return src;
        }

        if (size === 'master') {
            return this.removeProtocol(src);
        }

        var match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);

        if (match) {
            var prefix = src.split(match[0]);
            var suffix = match[0];

            return this.removeProtocol(prefix[0] + '_' + size + suffix);
        } else {
            return null;
        }
    }

    function removeProtocol(path) {
        return path.replace(/http(s)?:/, '');
    }

    return {
        preload: preload,
        loadImage: loadImage,
        imageSize: imageSize,
        getSizedImageUrl: getSizedImageUrl,
        removeProtocol: removeProtocol
    };
})();

/**
 * Variant Selection scripts
 * ------------------------------------------------------------------------------
 *
 * Handles change events from the variant inputs in any `cart/add` forms that may
 * exist. Also updates the master select and triggers updates when the variants
 * price or image changes.
 *
 * @namespace variants
 */

slate.Variants = (function () {

    /**
     * Variant constructor
     *
     * @param {object} options - Settings from `product.js`
     */
    function Variants(options) {
        this.$container = options.$container;
        this.product = options.product;
        this.singleOptionSelector = options.singleOptionSelector;
        this.originalSelectorId = options.originalSelectorId;
        this.enableHistoryState = options.enableHistoryState;
        this.priceIsQuote = false;
        this.currentVariant = this._getVariantFromOptions();

        $(this.singleOptionSelector, this.$container).on('change', this._onSelectChange.bind(this));
    }

    Variants.prototype = $.extend({}, Variants.prototype, {

        /**
         * Get the currently selected options from add-to-cart form. Works with all
         * form input elements.
         *
         * @return {array} options - Values of currently selected variants
         */
        _getCurrentOptions: function () {
            var currentOptions = $.map($(this.singleOptionSelector, this.$container), function (element) {
                var $element = $(element);
                var type = $element.attr('type');
                var currentOption = {};

                if (type === 'radio' || type === 'checkbox') {
                    if ($element[0].checked) {
                        currentOption.value = $element.val();
                        currentOption.index = $element.data('index');

                        return currentOption;
                    } else {
                        return false;
                    }
                } else {
                    currentOption.value = $element.val();
                    currentOption.text = $element.find('option:selected').text();
                    currentOption.index = $element.data('index');

                    return currentOption;
                }
            });

            // remove any unchecked input values if using radio buttons or checkboxes
            currentOptions = slate.utils.compact(currentOptions);

            return currentOptions;
        },

        /**
         * Find variant based on selected values.
         *
         * @param  {array} selectedValues - Values of variant inputs
         * @return {object || undefined} found - Variant object from product.variants
         */
        _getVariantFromOptions: function () {
            var selectedValues = this._getCurrentOptions();
            var variants = this.product.variants;
            var found = false;

            variants.forEach(function (variant) {
                if (typeof variant.tags === 'undefined') {
                    satisfied = false;

                    return;
                }

                var satisfied = true;

                selectedValues.forEach(function (option) {

                    if (!satisfied) {
                        return;
                    }

                    if (option.index.includes('option')) {
                        satisfied = (option.value === variant[option.index]);

                        return;
                    }

                    if (option.index === 'stone-type') {
                        satisfied = variant.tags.indexOf(`Stone Type:${option.value}`) >= 0;

                        return;
                    }

                    if (option.index === 'metal-alloy' && $('[data-index="metal-alloy"] option').length > 1) {
                        satisfied = variant.tags.indexOf(`Metal:${option.value}`) >= 0
                            || variant.tags.indexOf(`Metal Group:${option.value}`) >= 0;

                        return;
                    }
                });

                if (satisfied) {
                    found = variant;
                }
            });

            console.log(`${found ? 'Found' : 'Not found'}`, selectedValues, variants);

            return found || null;
        },

        /**
         * Event handler for when a variant input changes.
         */
        _onSelectChange: function () {
            var variant = this._getVariantFromOptions();

            currentVariant = getCurrentVariant()

            if (!variant) return false;

            $(document).trigger('variantChange', [variant]);

            this._updateMasterSelect(variant);
            this._updatePrice(variant);
            this._updateTitle(variant);
            this._updateDescription(variant);
            this._updateAttributes(variant);
            this._updateSku(variant);
            this._updateMatchingProducts(variant);
            this._updateCompleteTheLookProducts(variant);
            this._updateImages(variant);
            
            this.currentVariant = variant;

            if (this.enableHistoryState) {
                this._updateHistoryState(variant);
            }
        },

        /**
         * Trigger event when variant image changes
         *
         * @param  {object} variant - Currently selected variant
         * @return {event}  variantImageChange
         */
        _updateImages: function (variant) {
            var variantImage = variant.featured_image || {};
            if (this.currentVariant) {
                var currentVariantImage = this.currentVariant.featured_image || {};

                if (!variant.featured_image || variantImage.src === currentVariantImage.src) {
                    return;
                }
            }

            if (variant.images && variant.images.length > 0) {
                this.$container.trigger({
                    type: 'variantImageChange',
                    variant: variant
                });
            }
        },

        /**
         * Trigger event when variant price changes.
         *
         * @param  {object} variant - Currently selected variant
         * @return {event} variantPriceChange
         */
        _updatePrice: function (variant) {            
            if (variant.available === false && !isClearanceVariant) {
                const $priceElement = this.$container.find('[data-product-price]');
                $priceElement.html('Quote');
                this.priceIsQuote = true;
                return;
            }

            this.$container.trigger({
                type: 'variantPriceChange',
                variant: variant
            });


            // if (this.priceIsQuote) {
            //   this.$container.trigger({
            //     type: 'variantPriceChange',
            //     variant: variant
            //   });
            //   this.priceIsQuote = false;
            // }

            // if (variant.price === this.currentVariant.price && variant.compare_at_price === this.currentVariant.compare_at_price) {
            //     return;
            // }

            // this.$container.trigger({
            //     type: 'variantPriceChange',
            //     variant: variant
            // });
        },

        _updateTitle: function(variant) {
            this.$container.trigger({
                type: 'variantTitleChange',
                variant: variant
            })
        },

        _updateDescription: function(variant) {
            this.$container.trigger({
                type: 'variantDescriptionChange',
                variant: variant
            })
        },

        _updateAttributes: function(variant) {
            this.$container.trigger({
                type: 'variantAttributesChange',
                variant: variant
            })
        },

        _updateSku: function(variant) {
            this.$container.trigger({
                type: 'varaintSKUChange',
                variant: variant
            })
        },

        _updateMatchingProducts: function(variant) {
            this.$container.trigger({
                type: 'variantMatchingProductsChange',
                variant: variant
            })
        },

        _updateCompleteTheLookProducts: function(variant) {
            this.$container.trigger({
                type: 'variantCompleteTheLookProductsChange',
                variant: variant
            })
        },

        /**
         * Update history state for product deeplinking
         *
         * @param  {variant} variant - Currently selected variant
         * @return {k}         [description]
         */
        _updateHistoryState: function (variant) {
            if (!history.replaceState || !variant) {
                return;
            }

            const url = new URL(window.location.href)
            const searchParams = url.searchParams
            const queryID = searchParams.get('queryID');

            var newParams = 'variant=' + variant.id;

            if (queryID) {
                newParams += '&queryID=' + queryID;
            }

            var newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?' + newParams;
            window.history.replaceState({path: newurl}, '', newurl);
        },

        /**
         * Update hidden master select of variant change
         *
         * @param  {variant} variant - Currently selected variant
         */
        _updateMasterSelect: function (variant) {
            $(this.originalSelectorId, this.$container)[0].value = variant.id;
        }
    });

    return Variants;
})();


var queryProductFragment = `
    id
    title
    descriptionHtml
    handle
    tags
    options {
      name
      values
    }
    images(first: 10) {
      edges {
        node {
          originalSrc
        }
      }
    }

    product_attributes: metafields(identifiers: [
      {namespace: "product_attributes", key: "001"}
      {namespace: "product_attributes", key: "002"}
      {namespace: "product_attributes", key: "003"}
      {namespace: "product_attributes", key: "004"}
      {namespace: "product_attributes", key: "005"}
      {namespace: "product_attributes", key: "006"}
      {namespace: "product_attributes", key: "007"}
      {namespace: "product_attributes", key: "008"}
      {namespace: "product_attributes", key: "009"}
      {namespace: "product_attributes", key: "010"}
      {namespace: "product_attributes", key: "011"}
      {namespace: "product_attributes", key: "012"}
      {namespace: "product_attributes", key: "013"}
      {namespace: "product_attributes", key: "014"}
      {namespace: "product_attributes", key: "015"}
      {namespace: "product_attributes", key: "016"}
      {namespace: "product_attributes", key: "017"}
      {namespace: "product_attributes", key: "018"}
      {namespace: "product_attributes", key: "019"}
      {namespace: "product_attributes", key: "020"}
      {namespace: "product_attributes", key: "021"}
      {namespace: "product_attributes", key: "022"}
      {namespace: "product_attributes", key: "023"}
      {namespace: "product_attributes", key: "024"}
      {namespace: "product_attributes", key: "025"}
    ]) {
      id
      namespace
      key
      value
    }

    internal_attributes: metafields(identifiers: [
      {namespace: "internal_attributes", key: "001"}
      {namespace: "internal_attributes", key: "002"}
      {namespace: "internal_attributes", key: "003"}
      {namespace: "internal_attributes", key: "004"}
      {namespace: "internal_attributes", key: "005"}
      {namespace: "internal_attributes", key: "006"}
      {namespace: "internal_attributes", key: "007"}
      {namespace: "internal_attributes", key: "008"}
      {namespace: "internal_attributes", key: "009"}
      {namespace: "internal_attributes", key: "010"}
      {namespace: "internal_attributes", key: "011"}
      {namespace: "internal_attributes", key: "012"}
      {namespace: "internal_attributes", key: "013"}
      {namespace: "internal_attributes", key: "014"}
      {namespace: "internal_attributes", key: "015"}
    ]) {
      id
      namespace
      key
      value
    }

    matching_products: metafields(identifiers: [
      {namespace: "matching_products", key: "matching_products"}
    ]) {
      id
      namespace
      key
      value
    }

    complete_the_look_products: metafields(identifiers: [
      {namespace: "complete_the_look", key: "complete_the_look"}
    ]) {
      id
      namespace
      key
      value
    }

    variants(first: 50) {
      edges {
        node {
          id
          title
          sku
          selectedOptions {
            name
            value
          }
          priceV2 {
            amount
          }
          compareAtPriceV2 {
            amount
          }
        }
      }
    }
`
//https://${window.storeDomain}/api/2022-07/graphql
//Caching URL - https://secrets-shhh-q-cache.stellate.sh/
function getProductData(query) {
    return new Promise((resolve, reject) => {
      fetch(`https://${window.storeDomain}/api/2024-07/graphql`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        "X-Shopify-Storefront-Access-Token": window.accessToken
      },
      body: JSON.stringify({
        query: query
      }),
    })
    .then(res => { return res.json() })
    .then(r => { resolve(r) })
    .catch(error => {
      console.log(error.message)
    })
    })
}

/*================ Sections ================*/
/**
 * Product Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Product template.
 *
 * @namespace product
 */

theme.Product = (function () {

    var selectors = {
        addToCart: '[data-add-to-cart]',
        addToCartText: '[data-add-to-cart-text]',
        buyNowWrap: '.buy-now-wrap',
        btnOutOfStock: '.btn--out-of-stock',
        comparePrice: '[data-compare-price]',
        comparePriceText: '[data-compare-text]',
        originalSelectorId: '[data-product-select]',
        priceWrapper: '[data-price-wrapper]',
        productFeaturedImage: '[data-product-featured-image]',
        productVideo: '[data-product-video]',
        productJson: '[data-product-json]',
        productTitle: '[data-product-title]',
        productDescription: '[data-product-description]',
        productAttributes: '[data-product-attributes]',
        productPrice: '[data-product-price]',
        productSku: '[data-product-sku]',
        productThumbs: '[data-product-single-thumbnail]',
        singleOptionSelector: '[data-single-option-selector]',
    };

    var afteraySvg = document.querySelector('.icon-afterpay-logo');
    var zippaySvg = document.querySelector('.icon-zippay-logo');
    if (afteraySvg) {
        $(afteraySvg).addClass("icon--full-color");
    }
    if (zippaySvg) {
        $(zippaySvg).addClass("icon--full-color");
    }

    /**
     * Product section constructor. Runs on page load as well as Theme Editor
     * `section:load` events.
     * @param {string} container - selector for the section container DOM element
     */
    function Product(container) {
        this.$container = $(container);

        // Stop parsing if we don't have the product json script tag when loading
        // section in the Theme Editor
        if (!$(selectors.productJson, this.$container).html()) {
            return;
        }

        var sectionId = this.$container.attr('data-section-id');
        this.productSingleObject = JSON.parse($(selectors.productJson, this.$container).html());

        var options = {
            $container: this.$container,
            enableHistoryState: this.$container.data('enable-history-state') || false,
            singleOptionSelector: selectors.singleOptionSelector,
            originalSelectorId: selectors.originalSelectorId,
            product: this.productSingleObject
        };

        this.settings = {};
        this.namespace = '.product';
        this.variants = new slate.Variants(options);
        this.$featuredImage = $(selectors.productFeaturedImage, this.$container);

        this.$container.on('variantChange' + this.namespace, this.updateAddToCartState.bind(this));
        this.$container.on('variantPriceChange' + this.namespace, this.updateProductPrices.bind(this));
        this.$container.on('variantTitleChange' + this.namespace, this.updateProductTitle.bind(this));
        this.$container.on('variantDescriptionChange' + this.namespace, this.updateProductDescription.bind(this));
        this.$container.on('variantAttributesChange' + this.namespace, this.updateProductAttributes.bind(this));
        this.$container.on('varaintSKUChange' + this.namespace, this.updateProductSku.bind(this));
        this.$container.on('variantMatchingProductsChange' + this.namespace, this.updateMatchingProducts.bind(this));
        this.$container.on('variantCompleteTheLookProductsChange' + this.namespace, this.updateCompleteTheLookProducts.bind(this));

        if (this.$featuredImage.length > 0) {
            this.settings.imageSize = slate.Image.imageSize(this.$featuredImage.attr('src'));
            slate.Image.preload(this.productSingleObject.images, this.settings.imageSize);

            this.$container.on('variantImageChange' + this.namespace, this.updateProductImage.bind(this));
        }

        // Listen to the form submit event
        var productThis = this;

        var form = document.querySelector('.product__form');
        form.addEventListener('submit', this.addProductHandler.bind(this));

        /**
         * Custom fee modal.
         */
        const customFeeModal = document.querySelector('.custom-fee-modal');
        const customFeeModalTrigger = document.querySelector('.custom-fee-modal-trigger');

        if(customFeeModal && customFeeModalTrigger) {
          const customFeeModalClose = document.querySelector('.custom-fee-modal__close');

          const toggleCustomModalVisibility = () => {
            customFeeModal.style.display = customFeeModal.style.display === 'none' ? 'flex' : 'none';
          }
          customFeeModalClose.addEventListener('click', toggleCustomModalVisibility);
          customFeeModalTrigger.addEventListener('click', toggleCustomModalVisibility);
        }

        this.$productImages = $(selectors.productFeaturedImage);
        this.$thumbs = $(selectors.productThumbs);

        if (this.$productImages.length) {
            $('.product__image-slider').slick({
                slidesToShow: 1,
                arrows: false,
                dots: true,
                accessibility: false
            });

            $('.product__image-slider').on('beforeChange', function (event, slick, currentSlide, nextSlide) {
                var selectedVariant = slick.$slides.get(nextSlide).dataset.variantOption;
                var selectVariant = $('#SingleOptionSelector-1');

                if (selectVariant.length > 0 && selectedVariant !== '') {
                    selectVariant.val(selectedVariant)
                    productThis.variants._onSelectChange();
                }
            });
        }
    }


    Product.prototype = $.extend({}, Product.prototype, {

        /**
         * Updates the DOM state of the add to cart button
         *
         * @param {boolean} enabled - Decides whether cart is enabled or disabled
         * @param {string} text - Updates the text notification content of the cart
         */
        updateAddToCartState: function (evt) {
            var variant = evt.variant;

            // TODO: readd back check with "available"

            if (variant) {
                $(selectors.priceWrapper, this.$container).removeClass('hide');
            } else {
                $(selectors.addToCart, this.$container).prop('disabled', true).hide();
                $(selectors.addToCartText, this.$container).html(theme.strings.unavailable);
                $(selectors.buyNowWrap, this.$container).hide();
                $(selectors.btnOutOfStock, this.$container).show();
                $(selectors.priceWrapper, this.$container).addClass('hide');
                return;
            }

            if (variant.available) {
                $(selectors.addToCart, this.$container).prop('disabled', false).show();
                $(selectors.addToCartText, this.$container).html(theme.strings.addToCart);
                $(selectors.buyNowWrap, this.$container).show();
                $(selectors.btnOutOfStock, this.$container).hide();
            } else {
                // $(selectors.addToCart, this.$container).prop('disabled', true).hide();
                $(selectors.addToCartText, this.$container).html(theme.strings.soldOut);
                $(selectors.buyNowWrap, this.$container).hide();
                $(selectors.btnOutOfStock, this.$container).show();
            }

            // Also update the sku
            var skuString = variant.sku === '' ? '' : 'SKU - ' + variant.sku;
            $(selectors.productSku).html(skuString);
        },


        /**
         * Updates the DOM with specified prices
         *
         * @param {string} productPrice - The current price of the product
         * @param {string} comparePrice - The original price of the product
         */
        updateProductPrices: function (evt) {
            var variant = evt.variant;
            var $comparePrice = $(selectors.comparePrice, this.$container);
            var $compareEls = $comparePrice.add(selectors.comparePriceText, this.$container);

            var newPrice = slate.Currency.formatMoney(variant.price, '{{amount}}').split('.')
            var priceHtml = theme.moneyFormat.replace('{{amount}}', '')
            priceHtml += `${newPrice[0]}<sup>.${newPrice[1]}</sup>`
            $(selectors.productPrice, this.$container).html(priceHtml);

            if (variant.compare_at_price > variant.price) {
                $comparePrice.html(slate.Currency.formatMoney(variant.compare_at_price, theme.moneyFormat));
                $compareEls.removeClass('hide');
            } else {
                $comparePrice.html('');
                $compareEls.addClass('hide');
            }
        },

        /**
         * Updates the DOM with specified title
         *
         * @param {string} productTitle - The current title of the product
         */
        updateProductTitle: function(evt) {
            var variant = evt.variant;
            var $title = $(selectors.productTitle, this.$container)

            $title.html(variant.productTitle)
        },


        updateProductDescription: function(evt) {
            var variant = evt.variant;
            var $description = $(selectors.productDescription);

            $description.html(variant.productDescription.replaceAll('<br>', '</p><p>'))
                .closest('.accordian-container')
                .toggle(
                    variant.productDescription !== ''
                    && variant.productDescription != '<p><br></p>'
                    && variant.productDescription != '<p></p>'
                );
        },


        updateProductAttributes: function(evt) {
            if (typeof evt.variant === 'undefined') {
                var variant = getCurrentVariant();
            } else {
                var variant = evt.variant;
            }

            var $attributes = $(selectors.productAttributes);
            var attributes = Object.assign({}, variant.attributes);
            var internalAttributes = Object.assign({}, variant.internalAttributes)

            var mappedAttributes = {
                "Stone Type": {
                    "lab grown aaaaa cubic zirconia": "Sustainable lab-grown diamond simulants, mineral base Zirconium Oxide, not Carbon. D-F colour, flawless to VVS clarity, excellent cut. Durable 8.5 on Mohs scale of hardness, eco-friendly with a fraction of the environmental cost than a mined diamond. Conflict free as defined by the Kimberly Process. Superior light dispersion rate 0.058 compared to 0.044 for a mined diamond. Highest grade AAAAA Cubic Zirconia."
                }
            } 

            var attributeOrder = [
                "Product SKU",
                "Style",
                "Metal Colour",
                "Metal Content",
                "Stone Colour",
                "Stones Description",
                "Stone Shape",
                "Stones Shape",
                "Stone Shape(s)",
                "Total Number of Stones",
                "Total diamond weight",
                "Total equivalent diamond weight",
                "Colour",
                "Clarity",
                "Colour stones",
                "Chain Included",
                "Chain Adjustable",
                "Chain metal",
                "Centre stone weight",
                "Centre Stone Equivalent Weight",
                "Center Stone Colour",
                "Center Stone Cut Grade",
                "Center Stone Certificate",
                "Length",
                "Width",
                "Clasp",
                "Number Of Stones",
                "Stone Colour Grade",
                "Stone Clarity Grade",
                "Stone Cut Grade",
                "Stone Certificate",
                "Lifetime Gemstone Brilliance Guarantee",
                "Lifetime Gemstone Loss Guarantee",
            ]

            var attributesListItems = '';
            for (let i = 0; i < attributeOrder.length; i ++) {
                var attr = attributeOrder[i];
                if (attributes && attributes[attr] && !Object.keys(mappedAttributes).includes(attr)) {
                    attributesListItems += `<li>${attr}: ${attributes[attr]}</li>`
                    delete attributes[attr];
                }
            }

            for (const key in attributes) {
                if (!Object.keys(mappedAttributes).includes(key))
                    attributesListItems += `<li>${key}: ${attributes[key]}</li>`
            }

            var whiteStoneDescription = ''
            var otherStoneDescription = ''
            var COLOUR_DISCLAIMER_1 = null
            var COLOUR_DISCLAIMER_2 = null

            for (const key in internalAttributes) {
                var value = internalAttributes[key]
                if (key === 'WHITE' && value === 'Y')
                    whiteStoneDescription = 'Sustainable lab-grown diamond simulants, grown from mineral base zirconium oxide, not carbon. Highest quality AAAAA Cubic Zirconia. D-F colour, flawless to VVS clarity, exceptionally cut. Durable, eco-friendly, with a superior light dispersion rate to a mined diamond'
                if (key === 'COLOUR_DISCLAIMER_2') {
                    COLOUR_DISCLAIMER_2 = value
                    }
                if (key === 'COLOUR_DISCLAIMER_1') {
                        COLOUR_DISCLAIMER_1 = value
                }
            }
            if (COLOUR_DISCLAIMER_1 !== null && COLOUR_DISCLAIMER_2 !== null) {
                otherStoneDescription = `Our sustainable lab-grown ${COLOUR_DISCLAIMER_1} stones recreate the colour and brilliance of the finest gemstones. They do not share the same chemical properties as their mined counterparts. They are the highest quality ${COLOUR_DISCLAIMER_2}`
            }

            if (whiteStoneDescription.length > 0)
                attributesListItems += `<li class="no-cap">White Stone Type: ${whiteStoneDescription}.</li>`
            if (otherStoneDescription.length > 0)
                attributesListItems += `<li class="no-cap">Colour Stone Type: ${otherStoneDescription}.</li>`         


            if (attributesListItems.length > 0) {
                var attributesHTML = `<ul>${attributesListItems}</ul>`

                $attributes.html(attributesHTML)
                $attributes.data('variant', variant.id);
            } else {
                console.log(variant.id + ' missing attributes')
            }
        },


        updateProductSku: function(evt) {
            var variant = evt.variant;
            var $sku = $(selectors.productSku, this.$container)

            $sku.html(variant.sku)
        },


        formatProductCard: function(product) {
            return `
            <div class="grid__item small-down--one-half medium-up--one-quarter">
                <div class="product-card">
                    <div class="product-card__image">
                        <a href="${product.onlineStoreUrl}">
                            <img src="${product.images[0].src}" width="150" height="150">
                        </a>
                    </div>
                    <div class="product-card__title">
                        <a href="${product.onlineStoreUrl}">
                            ${product.title}
                        </a>
                    </div>
                    <div class="product-card__price">
                        <span class="dollar-sign">$</span>${product.variants[0].price}
                    </div>
                </div>
            </div>`
        },


        updateLinkedProductsSlider: function(products, sliderClass) {
            var sliderContainer = $(sliderClass)
            var accordianContainer = sliderContainer.closest('.accordian-container')
            if (products) {
                if (products.length > 0) {
                    sliderContainer.empty().removeClass('slick-initialized')
                    let productSlidesHTML = ''
                    for (let i = 0; i < products.length; i ++) {
                        let product = products[i]
                        productSlidesHTML += this.formatProductCard(product)
                    }
                    sliderContainer.append(productSlidesHTML)
                    accordianContainer.removeClass('hidden')
                    this.initMatchingProductsSlick(sliderClass)
                } else {
                    accordianContainer.addClass('hidden')
                }
            }

            accordianContainer.toggleClass('hidden', accordianContainer.find('.slick-slide').length === 0);
        },


        updateMatchingProducts: function(evt) {
            var variant = evt.variant;
            var products = variant.matching_products;
            var sliderClass = '.matching-products__slick';
            this.updateLinkedProductsSlider(products, sliderClass);
        },


        updateCompleteTheLookProducts: function(evt) {
            var variant = evt.variant;
            var products = variant.complete_the_look_products 
            var sliderClass = '.complete-the-look__slick'
            this.updateLinkedProductsSlider(products, sliderClass);
        },


        initMatchingProductsSlick: function(elementClass) {
            $(elementClass).slick({
              centerMode: false,
              centerPadding: '0px',
              slidesToShow: 4,
              slidesToScroll: 4,
              arrows: true,
              infinite: true,
              responsive: [
                {
                  breakpoint: 769,
                  settings: {
                    centerPadding: '8px',
                    focusOnSelect: true,
                    centerMode: true,
                    variableWidth: true,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    arrows: false,
                  }
                }
              ]
            });
        },


        /**
         * Updates the DOM with the specified image URL
         *
         * @param {string} src - Image src URL
         */
        updateProductImage: function (evt) {
            let variant = evt.variant;

            let galleryImagesHtml = '';
            let sliderImagesHtml = '';

            for (let i = 0; i < variant.images.length; i ++) {
                let image  = variant.images[i];

                galleryImagesHtml += `<div class="product__image">
                  <img src="${image.src}" alt="${variant.productTitle}">
                </div>`;

                sliderImagesHtml += `<div class="product__image" data-product-background-image style="background-image: url(${image.src})">
                    <img data-product-featured-image src="${image.src}" />
                </div>`;
            }

            if (variant.images.length === 0) {
                galleryImagesHtml = `<div class="product__image-grid col-1">
                  <div class="product__image">
                    <img src="https://placehold.co/1000x600/FFF/b39763.webp?font=montserrat&text=COMING%20SOON" alt="Coming soon...">
                  </div>
                </div>`;

                sliderImagesHtml = `<div class="product__image" data-product-background-image style="background-image: url(${image.src})">
                    <img data-product-featured-image src="https://placehold.co/1000x1000/FFF/b39763.webp?font=montserrat&text=COMING%20SOON" />
                </div>`;
            }

            $('.product__image-grid').html(galleryImagesHtml)
                .toggleClass('col-1', variant.images.length <= 1)
                .toggleClass('col-2', variant.images.length > 1);

            $('[data-product-featured-image]')
                .closest('.slick-slider')
                .slick('unslick')
                .html(sliderImagesHtml)
                .slick({
                    slidesToShow: 1,
                    arrows: false,
                    dots: true,
                    accessibility: false
                });
        },


        getMatchingProducts: function(handle, key=null) {
            var s3Endpoint = 'https://ss-handles.s3.ap-southeast-2.amazonaws.com/'
            var matchingProducts = []
            var _key = key

            var getMatchingDict = () => new Promise((resolve) => {
                fetch(`${s3Endpoint}${handle}.json`, {
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json'
                    },
                    method: "GET",
                })
                .then(response => {
                    if (response.ok)
                        return response.json()
                    return Promise.reject('404')
                })
                .then(response => {
                    if (key) {
                        resolve(response[key])
                    } else {
                        resolve(response)
                    }
                })
                .catch(err => {
                    resolve()
                })
            })

            var getProductData = (handle) => new Promise((resolve) => {
                const productQuery = client.graphQLClient.query((root) => {
                    root.add(
                        "productByHandle",
                        { args: { handle: `${handle}` } },
                        (product) => {
                            product.add("title");
                            product.add("handle");
                            product.add("id");
                            product.add("onlineStoreUrl");
                            product.addConnection(
                                "images",
                                { args: {first: 10} },
                                (image) => {
                                    image.add("src");
                                }
                            ),
                            product.addConnection(
                                "variants",
                                { args: { first: 99 } },
                                (variant) => {
                                    variant.add("id");
                                    variant.add("title");
                                    variant.add("price");
                                    variant.add("compareAtPrice");
                                    variant.add("availableForSale");
                                }
                            )
                        }
                    );
                });

                client.graphQLClient.send(productQuery)
                .then((queryResponse) => {
                    // append_matching_product_function()
                    var { data: {productByHandle: productResponse} } = queryResponse
                    if (productResponse) {
                        if (!matchingProducts[handle])
                            matchingProducts[handle] = []
                        var { variants: { edges: variants }, images: { edges: images }} = productResponse
                        variants = variants.map((v) => {
                            var variant = v.node
                            var id = variant.id.split('/')
                            id = id[id.length - 1]
                            variant.id = id
                            return variant
                        })
                        images = images.map((i) => {
                            return i.node
                        })
                        productResponse.variants = variants
                        productResponse.images = images
                        matchingProducts[handle].push(productResponse)
                    }
                    resolve()
                })
                .catch((error) => {
                    console.error(error)
                    resolve()
                });
            })

            return new Promise((resolve) => {
                getMatchingDict().then((matchingHandles) => {
                    var handlePromises = []

                    if (matchingHandles) {
                        matchingHandles.forEach((handle) => {
                            handlePromises.push(getProductData(handle))
                        })
        
                        Promise.all(handlePromises).then(() => {
                            var matchingProductArr = []
    
                            if (_key) {
                                for (var i of Object.keys(matchingProducts)) {
                                    matchingProductArr.push(matchingProducts[i][0])
                                }
                                resolve(matchingProductArr)
                            } else {
                                resolve(matchingProducts)
                            }
                        })
                    } else {
                        resolve()
                    }
                })
            })
        },

        /**
         * Handler to add product to cart via ajax request
         */
        addProductHandler: function (e) {

            e.preventDefault();

            var sizeProp = e.target.querySelector('#Size');
            var spanText = e.target.querySelector('[data-add-to-cart-text]');
            // /**
            //  * In an ideal world, we can simply use the event.submitter property
            //  * however this is not supported in Safari and potentially other browsers.
            //  *
            //  * We need to have two submit buttons, as for special ring sizes a modal pops up
            //  * that asks the user to confirm that they are purchasing a special ring and click on a
            //  * different submit button than the original.
            //  *
            //  * As the secondary button is disabled by default, we instead check to see if it is enabled.
            //  * If it is enabled, it means that the secondary button was clicked.
            //  */
            // // const isSpecialOrderSubmit = e.submitter.matches(['[name="special-order-submit"]']);
            // const specialOrderSubmitButton = document.querySelector('[data-add-to-cart-custom-order]');
            // const isSpecialOrderSubmit = specialOrderSubmitButton && !specialOrderSubmitButton.disabled;

            if (sizeProp === null || sizeProp.value !== '') {

              // if (sizeProp !== null) {
              //   const isSpecialOrder = sizeProp.selectedOptions[0].classList.contains('special-order');
              //   const specialOrderModal = document.querySelector('.special-order-modal');
              //   if (isSpecialOrder && !isSpecialOrderSubmit) {

              //     if (!specialOrderModal) return;

              //     specialOrderModal.style.display = 'flex';
              //     return;
              //   }
              // }

                var form = e.target;
                var button = form.add;

                if (spanText.innerHTML === 'Choose a ring size') {
                    spanText.innerHTML = 'Add to cart';
                }

                var formData = {
                    id: form.id.value,
                    quantity: form.quantity.value
                };

                if (sizeProp) {
                    formData.properties = {
                        'Size': sizeProp.value
                    };
                }

                // Send the updated cart data

                var properties = {};

                if ($('.product__form #Size').length) {
                  properties = {
                        'Size': $('.product__form #Size').val()
                    }
                }
                // if (sizeProp !== null) {
                //   if(isSpecialOrderSubmit) {
                //     properties = {
                //       ...properties,
                //       'Custom Order': 'Yes'
                //     }
                //   }
                // }

                CartJS.addItem(formData.id, formData.quantity, properties, {
                    "success": function(data, textStatus, jqXHR) {

                        // /**
                        //  * Reset the special order modal.
                        //  */
                        // if (sizeProp !== null) {
                        //   if (isSpecialOrderSubmit) {
                        //     const specialOrderModal = document.querySelector('.special-order-modal');
                        //     const specialOrderModalInput = document.querySelector('#special-order-checkbox');
                        //     const specialOrderModalButton = document.querySelector('.special-order-submit');


                        //     specialOrderModal.style.display = 'none';
                        //     specialOrderModalInput.checked = false;
                        //     specialOrderModalButton.disabled = true;
                        //   }
                        // }

                        theme.cart.fetchData(function () {

                            theme.cart.updateBadges();
                            theme.cart.updateSubtotal();
                            theme.cart.updateCartItems(function () {
                                button.classList.remove('btn--loading');
                                theme.cart_slider.init();
                                theme.cart.openCartDrawer();
                                $(document).trigger('cart:change');
                                if (theme.cart.populateFreeGift)
                                    theme.cart.populateFreeGift();
                                ga('send', 'event', 'Product', 'addToCart');
                            });
                        });
                    },

                    // Define an error callback to display an error message.
                    "error": function(jqXHR, textStatus, errorThrown) {

                    }
                });
            } else {
                spanText.innerHTML = 'Choose a ring size';
                this.checkSize();
            }
        },

        checkSize: function () {
            var sizeProp = document.querySelector('#Size');

            sizeProp.addEventListener('change', function () {
                var spanText = document.querySelector('[data-add-to-cart-text]');
                spanText.innerHTML = 'Add to cart';
            });
        },

        /**
         * Event callback for Theme Editor `section:unload` event
         */
        onUnload: function () {
            this.$container.off(this.namespace);
        }
    });

    return Product;
})();

theme.productBtnBackTo = {
    init: function () {
        var productCtaBack = $('.product__cta-back');
        var currentUrl = window.location.href;

        if (productCtaBack.length == 0 || currentUrl.indexOf('/products/') == -1) {
            return false;
        }

        var referrer = document.referrer || '/';
        var ctaText = window.theme.strings.back;

        if (referrer.indexOf('collection') != -1) {
            ctaText = window.theme.strings.backToCategory;
        }

        if (referrer.indexOf('search') != -1) {
            ctaText = window.theme.strings.backToSearch;
        }

        productCtaBack.attr('href', referrer).find('span').text(ctaText);
    }
}

theme.productAccordion = {
    init: function () {
        $(".product-accordion__title").click(function () {
            if ($(this).siblings(".product-accordion__content").hasClass("show-accordion")) {
                $(this).siblings(".product-accordion__content").removeClass("show-accordion");
                $(this).find(".product-accordion__indicator").text("+");
            } else {
                $(".product-tabs__content").addClass("show-accordion");
                $(this).siblings(".product-accordion__content").addClass("show-accordion");
                $(this).find(".product-accordion__indicator").text("-");
            }
        });

        $(document).on('variantChange', function (e) {

            if (!e.variant) return false;

            var domVariant = e.variant,
                caratInfo = $('li:contains("Total Carat Equivalent:")');

            var newCaratValue = null
            for (var i = 0; i < productOptions.length; i++) {
                var option = productOptions[i]
                if (option.toLowerCase() === 'carat size')
                    newCaratValue = domVariant.options[i]
            }

            if (newCaratValue)
                caratInfo.html("Total Carat Equivalent: " + newCaratValue);
        });
    }

};

theme.Accordian = {
    init: function () {
        $(".accordian-title").click(function () {
            $(this).closest('.accordian-container').toggleClass('open');
        });
    }
}

theme.HeroSlider = (function () {

    /**
     * Constructor
     */
    function HeroSlider(container) {

        this.settings = container.dataset.sectionSettings || "{}";
        this.$slider = $(container).find('.slider');

        // Parse the settings string passed through from liquid
        var userSettings = JSON.parse(this.settings);

        // Create some defaults
        var defaultSettings = {
            infinite: true,
            autoplaySpeed: userSettings.slide_speed,
            speed: (userSettings.slide_speed / 2),
            responsive: [
                {
                    breakpoint: window.theme.settings.grid_medium || 768,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                }
            ]
        };

        // Merge the objects - userSettings will have precedence
        var sliderSettings = $.extend(defaultSettings, userSettings);
        // Init slick carousel
        this.$slider.slick(sliderSettings);
    }

    /**
     * Event handler that updates the fade setting based on slidesToShow
     */
    function slideHandler(e) {

        if (e.target.name.indexOf('slidesToShow')) {
            var fade = window.top.document.querySelector('[id="fade"]');

            if (e.target.value > 1) {
                fade.checked = false;
                fade.disabled = true;
            }
            else {
                fade.checked = true;
                fade.disabled = false;
            }
        }
    }

    /**
     * Shopify section methods
     */
    HeroSlider.prototype = $.extend({}, HeroSlider.prototype, {

        onSelect: function (e) {
            window.top.addEventListener('input', slideHandler);
            window.top.addEventListener('change', slideHandler);
        },

        onDeselect: function (e) {
            window.top.removeEventListener('input', slideHandler);
            window.top.removeEventListener('change', slideHandler);
        },

        onBlockSelect: function (e) {
            // Go to the currently selected block in slick carousel and pause
            var index = parseInt(e.target.dataset.slickIndex, 10);
            this.$slider.slick('slickGoTo', index).slick('slickPause');
        },

        onBlockDeselect: function (e) {
            // Resume carousel
            this.$slider.slick('slickPlay');
        }

    });

    return HeroSlider;
})();

theme.Testimonials = (function () {

    /**
     * Constructor
     */
    function Testimonials(container) {

        this.settings = container.dataset.sectionSettings || "{}";
        this.$slider = $(container).find('.slider');

        // Parse the settings string passed through from liquid
        var userSettings = JSON.parse(this.settings);

        // Create some defaults
        var defaultSettings = {
            infinite: true,
            autoplaySpeed: userSettings.slide_speed,
            speed: (userSettings.slide_speed / 2),
            responsive: [
                {
                    breakpoint: window.theme.settings.grid_medium || 768,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                }
            ]
        };

        // Merge the objects - userSettings will have precedence
        var sliderSettings = $.extend(defaultSettings, userSettings);
        // Init slick carousel
        this.$slider.slick(sliderSettings);
    }

    /**
     * Event handler that updates the fade setting based on slidesToShow
     */
    function slideHandler(e) {

        if (e.target.name.indexOf('slidesToShow')) {
            var fade = window.top.document.querySelector('[id="fade"]');

            if (e.target.value > 1) {
                fade.checked = false;
                fade.disabled = true;
            }
            else {
                fade.checked = true;
                fade.disabled = false;
            }
        }
    }

    /**
     * Shopify section methods
     */
    Testimonials.prototype = $.extend({}, Testimonials.prototype, {

        onSelect: function (e) {
            window.top.addEventListener('input', slideHandler);
            window.top.addEventListener('change', slideHandler);
        },

        onDeselect: function (e) {
            window.top.removeEventListener('input', slideHandler);
            window.top.removeEventListener('change', slideHandler);
        },

        onBlockSelect: function (e) {
            // Go to the currently selected block in slick carousel and pause
            var index = parseInt(e.target.dataset.slickIndex, 10);
            this.$slider.slick('slickGoTo', index).slick('slickPause');
        },

        onBlockDeselect: function (e) {
            // Resume carousel
            this.$slider.slick('slickPlay');
        }

    });

    return Testimonials;
})();

theme.featuredCollectionSlider = {
    // Function to kick in Slick slider for mobile
    //  on featured collection product cards.

    // Note: .not('slick-initialized') is to stop
    //  double firing on initialize when resizing.

    init: function () {
        // Global Variables
        const slickContainer = $('[data-section-type="featured-collection"] .grid.grid--uniform.slick-slider');
        const myWindow = $(window);
        const sliderSettings = {
            centerMode: true,
            arrows: false,
            dots: false,
            centerPadding: "20%",
            infinite: false
        };

        // On load, kick in slider
        if (myWindow.width() <= 768) {
            $(slickContainer)
                .not(".slick-initialized")
                .slick(sliderSettings);
        }

        // If on resize, kick in slider or kill
        myWindow.on("resize", function () {
            if (myWindow.width() <= 768) {
                $(slickContainer)
                    .not(".slick-initialized")
                    .slick(sliderSettings);
            } else {
                $(slickContainer).slick("unslick");
            }
        });
    }
};

theme.featuredArticleSlider = {
    // Function to kick in Slick slider for mobile
    //  on featured article cards.

    // Note: .not('slick-initialized') is to stop
    //  double firing on initialize when resizing.

    init: function () {
        // Global Variables
        const slickContainer = $('[data-section-type="featured-articles"] .grid.grid--uniform.slick-slider');
        const myWindow = $(window);
        const sliderSettings = {
            centerMode: true,
            arrows: false,
            dots: false,
            centerPadding: "20%",
            infinite: false
        };

        // On load, kick in slider
        if (myWindow.width() <= 768) {
            $(slickContainer)
                .not(".slick-initialized")
                .slick(sliderSettings);
        }

        // If on resize, kick in slider or kill
        myWindow.on("resize", function () {
            if (myWindow.width() <= 768) {
                $(slickContainer)
                    .not(".slick-initialized")
                    .slick(sliderSettings);
            } else {
                $(slickContainer).slick("unslick");
            }
        });
    }
};

theme.footerAccordion = {

    init: function () {

        $('.footer .nav--level-one .nav__item h5').click(function () {
            if ($(window).width() < 768) {
                $(this).next('.nav--level-two').slideToggle();

                if ($(this).find('.icon-plus').is(':visible')) {
                    $(this).find('.icon-plus').hide();
                    $(this).find('.icon-minus').show();
                } else {
                    $(this).find('.icon-plus').show();
                    $(this).find('.icon-minus').hide();
                }
            } else {
                $('.footer .nav--level-one .nav__item h5').unbind('click');
            }
        });
    }
};

/*================ Modules ================*/
theme.header = {

    /*
       * Public vars
       */
    isFixed: false,


    /**
     * The initialising code
     */
    init: function () {

        var self = this;

        // Scroll listener
        window.registerScrollHandler.push(this.scrollHandler.bind(this));
        this.scrollHandler();

        // Menu toggle
        var btnMenus = document.querySelectorAll('.header__btn--menu');
        btnMenus.forEach(el => el.addEventListener('click', self.btnMenuClickHandler.bind(self)));

        // Menu Close
        var btnMenuClose = document.querySelectorAll('.mobile-close-button')
        btnMenuClose.forEach(el => el.addEventListener('click', self.btnMenuCloseClickHandler.bind(self)));

        // Search Open
        var btnSearch = document.querySelectorAll('.header__btn--search')
        btnSearch.forEach(el => el.addEventListener('click', self.btnSearchClickHandler.bind(self)));

        var mobileSearchInput = document.querySelectorAll('.mobile-search-input');
        mobileSearchInput.forEach(el => el.addEventListener('focus', self.btnSearchClickHandler.bind(self)));

        // Menu item toggle
        var navLinks = document.querySelectorAll('.nav__item--has-child > a');
        navLinks.forEach(el => el.addEventListener('click', self.navLinkClickHandler.bind(self)));
    },


    /**
     * Window scroll handler, adds class to body if scrolled past banner
     */
    scrollHandler: function () {

        var waypoint = 0;

        // Check if we've scrolled past the banner
        if (window.pageYOffset > waypoint) {
            if (!this.isFixed) {
                document.body.classList.add('header-fixed');
                this.isFixed = true;
            }
        }
        else {
            if (this.isFixed) {
                document.body.classList.remove('header-fixed');
                this.isFixed = false;
            }
        }
    },


    /**
     * .header__btn--menu click handler
     */
    btnMenuClickHandler: function () {
        document.body.classList.toggle('menu-expanded');
        $('.suggestions-results').hide();
        var fade = document.querySelector('.menu-fade');
        fade.addEventListener('click', this.btnMenuCloseClickHandler.bind(this));
    },


    /**
     * .mobile-close-button click handler
     */
     btnMenuCloseClickHandler: function () {
        document.body.classList.remove('menu-expanded', 'search-expanded');
    },

    /**
     * .header__btn--search click handler
     */
    btnSearchClickHandler: function() {
        document.body.classList.remove('menu-expanded');
        document.body.classList.add('search-expanded');
        var fade = document.querySelector('.menu-fade');
        theme.mobileSearch.show();
        fade.addEventListener('click', this.btnMenuCloseClickHandler.bind(this));
    },

    /**
     * .nav__item--has-child > a click handler
     */
    navLinkClickHandler: function (e) {

        var w = window,
            d = document,
            docEl = d.documentElement,
            bodyEl = d.getElementsByTagName('body')[0],
            x = w.innerWidth || docEl.clientWidth || bodyEl.clientWidth,
            y = w.innerHeight || docEl.clientHeight || bodyEl.clientHeight;

        var windowWidth = x;

        function resize() {
            windowWidth = window.innerHeight;
        }

        window.addEventListener("resize", function () {
            resize();
        });

        if (windowWidth < 990) {

            e.preventDefault();
            e.target.parentElement.classList.toggle('nav__item--expanded');

        }
    }
};

theme.searchModal = function () {

    var banner = document.querySelector('.banner');
    var header = document.querySelector('.header');
    var container = document.querySelector('.search--modal');

    if (!container) {
        console.debug('no searchModal container found');
        return;
    }

    var inner = container.querySelector('.search__inner');
    var $container = $(container);

    updateOffset();

    var form = container.querySelector('form');
    var input = container.querySelector('input[name="q"]');
    // var closeButton = form.querySelector('.search__close');
    // var results = container.querySelector('.search__results .grid');
    //
    // var cachedTerm = '';
    // var currentAjaxRequest = null;

    var searchButton = document.querySelector('.header__btn--search');

    var isShowing = false;
    // searchButton.addEventListener('click', toggleModal);

    // input.addEventListener('input', inputHandler);
    form.addEventListener('submit', submitHandler);


    /**
     * Adds margin to search container so it sits under the header
     */
    function updateOffset() {

        var bannerHeight = banner ? banner.clientHeight : 0;
        var headerHeight = header.clientHeight || 0;
        var offset = bannerHeight + headerHeight;

        inner.style.marginTop = offset + 'px';
    }


    /**
     * Shows the search modal
     */
    function toggleModal() {
        if (isShowing) {
            hide();
        }
        else {
            show();
        }
    }


    /**
     * Shows the search modal
     */
    function show() {

        document.body.classList.add('search-modal-showing');

        // input.addEventListener('input', inputHandler);
        // closeButton.addEventListener('click', hide);
        // document.addEventListener('keydown', keydownHandler);
        input.addEventListener('focus', termFocusHandler);

        slate.a11y.trapFocus({
            $container: $container,
            namespace: 'container',
            $elementToFocus: $(input)
        });

        isShowing = true;
    }


    /**
     * Hides the search modal
     */
    function hide() {

        document.body.classList.remove('search-modal-showing');

        // input.removeEventListener('input', inputHandler);
        // closeButton.removeEventListener('click', hide);
        // document.removeEventListener('keydown', keydownHandler);
        input.removeEventListener('focus', termFocusHandler);

        slate.a11y.removeTrapFocus({
            $container: $container,
            namespace: 'container'
        });

        isShowing = false;
    }


    // /**
    //  * Handles the search input
    //  */
    // function inputHandler() {
    //
    // 	var term = input.value;
    //
    // 	if (term.length > 2 && term !== cachedTerm) {
    // 		querySearchTerm(term);
    // 	}
    //
    // 	cachedTerm = term;
    // }
    //
    //
    //
    // /**
    //  * Handles keydown
    //  */
    // function keydownHandler(e) {
    // 	switch (e.keyCode) {
    // 		//esc
    // 		case 27:
    // 			hide();
    // 			break;
    // 	}
    // }


    /**
     * Handles focus on term input
     */
    function termFocusHandler(e) {
        // Select all the text in the search box
        var input = e.target;
        input.setSelectionRange(0, input.value.length);
    }


    // /**
    //  * Ajax request for search term and prints out the results
    //  */
    // function querySearchTerm(term) {
    // 	// Encapsulate term in * wildcard to get partial matches
    // 	// Hit our json template for search term
    // 	var searchURL = '/search?type=product&q=*'+ term +'*';
    // 	// Stop any current calls
    // 	if (currentAjaxRequest != null) currentAjaxRequest.abort();
    //
    // 	currentAjaxRequest = $.getJSON(searchURL +'&view=json', function(data) {
    // 		// Reset results.
    // 		results.innerHTML = '';
    //
    // 		if (data.results_count == 0) {
    // 			results.innerHTML = "<div class='grid'><div class='grid__item text-center'><p>No results found.</p></div></div>";
    // 		}
    // 		else {
    // 			for (var i = 0, count = data.results.length; i < count; i++) {
    // 				results.innerHTML += data.results[i].markup;
    // 			}
    // 			// If there are more than 10, let's link to the search results page.
    // 			if (data.results_count > 10) {
    // 				results.innerHTML += '<p><a href="' + searchURL + '">See all results (' + data.results_count + ')</a></p>';
    // 			}
    // 		}
    // 	});
    // }


    /**
     * Handles the search form submission
     */
    function submitHandler(e) {
        // Wrap search term in wildcards
        e.preventDefault();

        var term = this.q.value;
        var searchURL = '/search?type=product&q=*' + term + '*';

        window.location = searchURL;
    }
};

theme.algoliaSearch = {
    init: function() {
        const self = this;

        const searchClient = algoliasearch(
            window.algoliaAppIndex,
            window.algoliaSearchKey
        );

        const insightsMiddleware = instantsearch.middlewares.createInsightsMiddleware({
            insightsClient: window.aa,
            insightsInitParams: {
              useCookie: true,
            }
        });

        self.search = instantsearch({
            indexName: 'shopify_products',
            searchClient,
            routing: true,
            distinct: true,
            clickAnalytics: true,
            searchFunction: function(searchFunctionHelper) {
              // Set query parameters here because they're not kept when someone
              // presses the Back button if set in the `init` function of a custom widget
              var page = searchFunctionHelper.getPage();
              searchFunctionHelper.setQueryParameter(
                'highlightPreTag',
                '<span class="ais-highlight">'
              );
              searchFunctionHelper.setQueryParameter('highlightPostTag', '</span>');
              searchFunctionHelper.setQueryParameter('distinct', true);
              searchFunctionHelper.setQueryParameter('getRankingInfo', true);
              searchFunctionHelper.setQueryParameter('ruleContexts', ['siteSearch']);
    
              searchFunctionHelper.setPage(page);
              searchFunctionHelper.search();
            },
        });

        self.search.use(insightsMiddleware)
    }
}

theme.searchDropdown = {

    init: function() {
        this.container = document.querySelector('.desktop-search')
        this.$container = $(this.container);

        const renderSearchBox = (renderOptions, isFirstRender) => {
            const { query, refine, clear, isSearchStalled, widgetParams } = renderOptions;
            const { placeholder } = widgetParams

            if (isFirstRender) {
                const input = document.createElement('input');

                //const loadingIndicator = document.createElement('span');
                //loadingIndicator.textContent = 'Loading...';

                const button = document.createElement('button');
                button.textContent = 'Clear';

                input.addEventListener('input', event => {
                    refine(event.target.value);
                });

                button.addEventListener('click', () => {
                    $('#searchbox input').val('');
                    clear();
                    $('.search-results[data-category="products"]').animate({scrollTop: 0});
                });

                widgetParams.container.appendChild(input);
                widgetParams.container.querySelector('input').placeholder = placeholder
                //widgetParams.container.appendChild(loadingIndicator);
                widgetParams.container.appendChild(button);

                if (widgetParams.container.querySelector('input').value === '') {
                    widgetParams.container.querySelector('input').value = query;
                }
            }
            //widgetParams.container.querySelector('span').hidden = !isSearchStalled;
        };

        const renderInfiniteHits = (renderOptions, isFirstRender) => {
            const {
            hits,
            results,
            widgetParams,
            showMore,
            isLastPage,
            } = renderOptions;

            const nextButton = document.createElement('button');
            nextButton.className = 'next-button';
            nextButton.textContent = 'Load More...';
            nextButton.disabled = isLastPage;

            nextButton.addEventListener('click', () => {
                var scrollPosition = $('.search-results[data-category="products"]').scrollTop();

                showMore();

                // Stay in current position.
                $('.search-results[data-category="products"]').animate({scrollTop: scrollPosition + 'px'})
            });

            var hitsHTML = '';

            var similarProductsFound = false;
            var hitsCount = 0;

            hitsHTML += hits.map(hit => {
                var compareAtPriceElement = '' 
                var price = slate.Currency.formatMoney(hit.price * 100, theme.moneyFormat)
                var compareAtPrice = slate.Currency.formatMoney(hit.compare_at_price * 100, theme.moneyFormat)
                if (hit.compare_at_price > 0) compareAtPriceElement = `<div class="compare-at-price">${compareAtPrice}</div>`

                var productBadges = '';
                for (let i = 0; i < hit.tags.length; i ++) {
                  let tag = hit.tags[i];
                  if (tag.startsWith('_badge|') || tag.startsWith('_Badge|')) {
                    productBadges += `<div class="badge"><span class="badge-arrow"></span>${tag.replace('_badge|', '').replace('_Badge|', '')}</div>`
                  }
                }

                if (productBadges.length > 0) {
                  productBadges = `<div class="product-badges">${productBadges}</div>`
                }

                var title = hit.title
                var titleWords = title.split(" ")
                title = titleWords.slice(0, 8).join(" ")
                if (titleWords.length >= 8) {
                    title += '...'
                }

                hitsCount++;

                itemHTML = '';

                if (! similarProductsFound && hit._rankingInfo.nbTypos > 0) {

                    var typoWords = [];

                    if (typeof results?.explain?.match?.alternatives != 'undefined') {
                        results.explain.match.alternatives.map(alt => {
                            if (alt.types.indexOf('original') >= 0) {
                                return;
                            }

                            typoWords.push(alt.words.join(', '));
                        });
                    }

                    itemHTML = `</div>
                    <div class="search-similar-results page-width">
                        <h2>Other products we found</h2>`

                    if (typoWords.length > 0) {
                        itemHTML += `<div class="search-term">Using similar words: ` + typoWords.join(', ') + `</div>`
                    }


                    itemHTML += `</div><div class="product-grid page-width">`;

                    similarProductsFound = true;
                }

                return itemHTML + `<div class="product-item ` + (! similarProductsFound && hits.length % 4 === 0 && (hits.length - 1) <= hitsCount ? 'hidden' : '') + `" data-algolia-index="${results.index}" data-algolia-queryid="${hit.__queryID}" data-algolia-objectid="${hit.objectID}" data-algolia-position="${hit.__position}" data-typos="${hit._rankingInfo.nbTypos}">
                    <a href="/products/${hit.handle}?queryID=${hit.__queryID}">
                    ${productBadges}
                    <div class="product-image">
                        <img src="${hit.image}" />
                    </div>
                    <div class="product-description">
                        <div class="product-price ${hit.compare_at_price > 0 && 'discounted'}">
                        <div class="price">${price}</div>
                        ${compareAtPriceElement}
                        </div>
                        <div class="product-title" title="` + hit.title + `">${title}</div>
                    </div>
                    </a>
                </div>`
            }).join('');

            $(widgetParams.container).html(`<div class="product-grid page-width">` + hitsHTML + `</div>
                <div class="product-grid-next-button">
                </div>`);

            document.querySelector('.product-grid-next-button').appendChild(nextButton);

            $('.desktop-search .search-results[data-category="products"] .product-grid:first-child')
                .toggle($('.desktop-search .search-results[data-category="products"] .product-grid:first-child .product-item').length > 0);
        };

        const renderSuggestionHits = (renderOptions) => {
            const {
                hits,
                widgetParams,
            } = renderOptions;

            var hitsHTML = '<ul class="suggestion-list">'
            var hitsCount = 0;

            hitsHTML += hits.map(hit => {

                hitsCount++;

                return `<li class="suggestion-item">
                    <button type="button" data-query="${hit.query}">
                        ${hit.query.replace($('#searchbox input').val(), `<span style="font-weight:normal;">${$('#searchbox input').val()}</span>`)}
                    </button>
                </li>`
            }).join('')

            hitsHTML += '</ul>'

            if ($('#searchbox input').val() === '' || hitsCount === 0) {
                hitsHTML = '';
                hitsCount = 0;
                $('.search-results[data-category="products"]').css({'maxHeight': 'calc(100vh - 190px)'});
            } else {
                $('.search-results[data-category="products"]').css({'maxHeight': 'calc(100vh - 190px - 10rem)'})
            }

            $('.desktop-search .search-suggestions').toggle(hitsCount > 0);

            widgetParams.container.innerHTML = hitsHTML
        }

        $('.search-suggestions').on('click', '.suggestion-item button', function () {
            $('#searchbox input').val($(this).data('query')).trigger('keyup');

            theme.algoliaSearch.search.helper.setQuery($(this).data('query')).search();

            return;
        });

        const renderCollectionHits = (renderOptions) => {
            const {
                hits,
                widgetParams,
            } = renderOptions;

            var hitsHTML = '<div class="collection-grid page-width">'

            hitsHTML += hits.map(hit => {
                return `<div class="collection-item">
                    <a href="/collections/${hit.handle}">
                    <div class="collection-image">
                        <div class="collection-title">${hit.title}</div>
                    </div>
                    </a>
                </div>`
            }).join('');

            hitsHTML += '</div>'

            widgetParams.container.innerHTML = hitsHTML;
        }

        const renderPageHits = (renderOptions) => {
            const {
                hits,
                widgetParams,
            } = renderOptions;

            var hitsHTML = '<div class="collection-grid page-width">'

            hitsHTML += hits.map(hit => {
                var image = '';
                if (hit.image)
                    image = `<img src="${hit.image}" />`

                return `<div class="collection-item">
                    <a href="/pages/${hit.handle}">
                    <div class="collection-image">
                        ${image}
                        <div class="collection-title">${hit.title}</div>
                    </div>
                    </a>
                </div>`
            }).join('');

            hitsHTML += '</div>'

            widgetParams.container.innerHTML = hitsHTML
        }

        const customSuggestionHits = instantsearch.connectors.connectInfiniteHits(
            renderSuggestionHits
        );

        const customCollectionHits = instantsearch.connectors.connectInfiniteHits(
            renderCollectionHits
        );

        const customPageHits = instantsearch.connectors.connectInfiniteHits(
            renderPageHits
        );

        const customInfiniteHits = instantsearch.connectors.connectInfiniteHits(
            renderInfiniteHits
        );
        
        const customSearchBox = instantsearch.connectors.connectSearchBox(
            renderSearchBox
        );

        var containerClass = '.desktop-search'
        if ($(window).width() < 989) {
            containerClass = '.mobile-search'
        }

        let timerId;

        theme.algoliaSearch.search.addWidgets([
            instantsearch.widgets.configure({
               explain: ['match.alternatives'],
            }),
            customInfiniteHits({
                container: document.querySelector(`${containerClass} .search-results[data-category="products"]`),
                showPrevious: true,
            }),
            customSearchBox({
                container: document.querySelector('#searchbox'),
                placeholder: 'Search Our Products',
                searchAsYouType: true,
                queryHook(query, search) {
                    clearTimeout(timerId)
                    timerId = setTimeout(() => search(query), 300);
                },
            }),

            instantsearch.widgets.index({
                    indexName: 'shopify_products_query_suggestions',
                })
                .addWidgets([
                      instantsearch.widgets.configure({
                        hitsPerPage: 4,
                      }),
                    customSuggestionHits({
                        container: document.querySelector(`${containerClass} .search-suggestions[data-category="suggestions"]`),
                    })
            ]),

            instantsearch.widgets.index({ indexName: 'shopify_collections' })
                .addWidgets([
                    customCollectionHits({
                        container: document.querySelector(`${containerClass} .search-results[data-category="categories"]`),
                    })
            ]),

            instantsearch.widgets.index({ indexName: 'shopify_pages' })
                .addWidgets([
                    customPageHits({
                        container: document.querySelector(`${containerClass} .search-results[data-category="pages"]`),
                    })
            ]),
            {
              init: function() {
                $(`${containerClass} .search-results`).on('click', '.product-grid .product-item', function () {
                    let userToken;
                    aa('getUserToken', null, (err, newUserToken) => {
                      if (err) {
                        console.error(err);
                        return;
                      }
                      userToken = newUserToken;
                    });

                    var clickData = {
                      userToken: userToken,
                      index: $(this).data('algolia-index'),
                      eventName: 'click',
                      queryID: $(this).data('algolia-queryid'),
                      objectIDs: [`${$(this).data('algolia-objectid')}`],
                      positions: [Number($(this).data('algolia-position'))],
                    };

                    window.aa('clickedObjectIDsAfterSearch', clickData);
                    saveForConversionTracking(clickData);
                });
              },
            },
        ]);

        theme.algoliaSearch.search.start();

        var button = this.container.querySelector('button');
        button.addEventListener('click', this.hide);

        const _this = this
        this.$container.find('.search-category').each(function() {
            $(this).on('click', _this.changeTab)
        });

        this.initialized = true;
    },

    show: function() {
        if (!this.initialized)
            this.init()
        
        document.body.classList.add('search-showing')
        $('.desktop-search').addClass('shown')

        var fade = document.querySelector('.fade');
        fade.addEventListener('click', this.hide.bind(this));

        var input = $(this.container).find('input')
        setTimeout(function() {
            input.focus()
        }, 1000)
    },

    hide: function() {
        document.body.classList.remove('search-showing')
        $('.desktop-search').removeClass('shown')

        var fade = document.querySelector('.fade');
        if (this.hide) {
            fade.removeEventListener('click', this.hide.bind(this));
        }
    },

    changeTab: function() {
        const category = $(this).attr('data-category')
        $(this).siblings().removeClass('active')
        $(this).addClass('active')
        $(this).closest('.desktop-search').find('.search-results').css("display", "none")
        $(`.desktop-search .search-results[data-category="${category}"]`).css("display", "block")
    },

    disableClose: function() {
        var button = this.container.querySelector('button');
        button.removeEventListener('click', this.hide);
    }
}

theme.mobileSearch = {
    init: function() {
        this.container = document.querySelector('.mobile-search-results')
        this.$container = $(this.container);

        const renderSearchBox = (renderOptions, isFirstRender) => {
            const { query, refine, widgetParams } = renderOptions;
            const { placeholder } = widgetParams
            const input = widgetParams.container.querySelector('input')

            if (isFirstRender) {
                input.addEventListener('input', event => {
                    refine(event.target.value);
                });
                input.placeholder = placeholder
            }

            if (input.value === '' && isFirstRender) {
                input.value = query;
            }
        };

        const renderInfiniteHits = (renderOptions, isFirstRender) => {
            const {
                hits,
                results,
                widgetParams,
                showMore,
                isLastPage,
            } = renderOptions;

            const nextButton = document.createElement('button');
            nextButton.className = 'next-button';
            nextButton.textContent = 'Load More...';

            nextButton.addEventListener('click', () => {
                showMore();
            });

            var hitsHTML = '<div class="product-grid">'

            var similarProductsFound = false;
            var hitsCount = 0;

            hitsHTML += hits.map(hit => {
                var compareAtPriceElement = '' 
                var price = slate.Currency.formatMoney(hit.price * 100, theme.moneyFormat)
                var compareAtPrice = slate.Currency.formatMoney(hit.compare_at_price * 100, theme.moneyFormat)
                if (hit.compare_at_price > 0) compareAtPriceElement = `<div class="compare-at-price">${compareAtPrice}</div>`
                var productBadges = ''
                if (hit.tags.includes('new')) {
                    productBadges = 
                    `<div class="product-badge"><span class="badge-arrow"></span>New</div>`
                }
                var title = hit.title
                var titleWords = title.split(" ")
                title = titleWords.slice(0, 8).join(" ")
                if (titleWords.length >= 8) {
                    title += '...'
                }

                hitsCount++;

                itemHTML = '';

                if (! similarProductsFound && hit._rankingInfo.nbTypos > 0) {
                    itemHTML = `</div>
                    <div class="search-similar-results">
                        <h2>Similar to</h2>
                        <div class="search-term">` + $('input.mobile-search-input').val() + `</div>
                    </div>
                    <div class="product-grid">`;

                    similarProductsFound = true;
                }

                return itemHTML + `<div class="product-item" data-algolia-index="${results.index}" data-algolia-queryid="${hit.__queryID}" data-algolia-objectid="${hit.objectID}" data-algolia-position="${hit.__position}">
                    <a href="/products/${hit.handle}?queryID=${hit.__queryID}">
                    ${productBadges}
                    <div class="product-image">
                        <img src="${hit.image}" />
                    </div>
                    <div class="product-description">
                        <div class="product-price ${hit.compare_at_price > 0 && 'discounted'}">
                        <div class="price">${price}</div>
                        ${compareAtPriceElement}
                        </div>
                        <div class="product-title">${title}</div>
                    </div>
                    </a>
                </div>`
            }).join('')

            hitsHTML += '</div>'

            widgetParams.container.innerHTML = hitsHTML
            widgetParams.container.appendChild(nextButton);

            widgetParams.container.querySelector('.next-button').disabled = isLastPage;
        };

        const renderSuggestionHits = (renderOptions) => {
            const {
                hits,
                widgetParams,
            } = renderOptions;

            var hitsHTML = '<ul class="suggestion-list">'
            var hitsCount = 0;

            hitsHTML += hits.map(hit => {
             hitsCount++;

                return `<li class="suggestion-item">
                    <button type="button" data-query="${hit.query}">
                        ${hit.query.replace($('input.mobile-search-input').val(), `<span style="font-weight:normal;">${$('input.mobile-search-input').val()}</span>`)}
                    </button>
                </li>`
            }).join('')

            hitsHTML += '</ul>'

            if ($('input.mobile-search-input').val() === '') {
                hitsHTML = '';
                hitsCount = 0;
            }

            $('button.mobile-search-input-clear').toggle(hitsCount > 0);
            $('.mobile-header .suggestions-results').toggle(hitsCount > 0);

            widgetParams.container.innerHTML = hitsHTML
        }

        if ($('input.mobile-search-input').val() === '') {
            $('button.mobile-search-input-clear').hide();
            $('.mobile-header .suggestions-results').hide();
        }

        $('.suggestions-results').on('click', '.suggestion-item button', function () {
            $('input.mobile-search-input').val($(this).data('query')).trigger('keyup');

            theme.algoliaSearch.search.helper.setQuery($(this).data('query')).search();

            return;
        });

        const renderCollectionHits = (renderOptions) => {
            const {
                hits,
                widgetParams,
            } = renderOptions;
        

            var hitsHTML = '<ul class="collection-grid">'

            hitsHTML += hits.map(hit => {
                return `<div class="collection-item">
                    <a href="/collections/${hit.handle}">
                    <div class="collection-image">
                        <div class="collection-title">${hit.title}</div>
                    </div>
                    </a>
                </div>`
            }).join('')

            hitsHTML += '</ul>'

            widgetParams.container.innerHTML = hitsHTML
        }

        const renderPageHits = (renderOptions) => {
            const {
                hits,
                widgetParams,
            } = renderOptions;

            var hitsHTML = '<ul class="collection-grid">'

            hitsHTML += hits.map(hit => {
                var image = '';
                if (hit.image)
                    image = `<img src="${hit.image}" />`

                return `<div class="collection-item">
                    <a href="/pages/${hit.handle}">
                    <div class="collection-image">
                        ${image}
                        <div class="collection-title">${hit.title}</div>
                    </div>
                    </a>
                </div>`
            }).join('')

            hitsHTML += '</ul>'

            widgetParams.container.innerHTML = hitsHTML
        }

        const customSuggestionHits = instantsearch.connectors.connectInfiniteHits(
            renderSuggestionHits
        );

        const customInfiniteHits = instantsearch.connectors.connectInfiniteHits(
            renderInfiniteHits
        );
        const customCollectionHits = instantsearch.connectors.connectInfiniteHits(
            renderCollectionHits
        )
        const customPageHits = instantsearch.connectors.connectInfiniteHits(
            renderPageHits
        )
        const customSearchBox = instantsearch.connectors.connectSearchBox(
            renderSearchBox
        );

        let timerId;

        theme.algoliaSearch.search.addWidgets([
            customInfiniteHits({
                container: document.querySelector('.mobile-search-results .search-products[data-category="products"]'),
                showPrevious: true,
            }),
            customSearchBox({
                container: document.querySelector('.mobile-search-input-container'),
                placeholder: 'Search Our Products',
                queryHook(query, search) {
                    clearTimeout(timerId)
                    timerId = setTimeout(() => search(query), 300);
                },
            }),

            instantsearch.widgets.index({
                    indexName: 'shopify_products_query_suggestions',
                })
                .addWidgets([
                    instantsearch.widgets.configure({
                        hitsPerPage: 4,
                    }),
                    customSuggestionHits({
                        container: document.querySelector('.mobile-header .suggestions-results'),
                    })
            ]),

            instantsearch.widgets.index({ indexName: 'shopify_collections' })
                .addWidgets([
                    customCollectionHits({
                        container: document.querySelector('.mobile-search-results[data-category="categories"]'),
                    })
            ]),

            instantsearch.widgets.index({ indexName: 'shopify_pages' })
                .addWidgets([
                    customPageHits({
                        container: document.querySelector('.mobile-search-results[data-category="pages"]'),
                    })
            ]),
            {
              init: function() {
                $('.mobile-search-results').on('click', '.product-grid .product-item', function () {
                    let userToken;
                    aa('getUserToken', null, (err, newUserToken) => {
                      if (err) {
                        console.error(err);
                        return;
                      }
                      userToken = newUserToken;
                    });

                    var clickData = {
                      userToken: userToken,
                      index: $(this).data('algolia-index'),
                      eventName: 'click',
                      queryID: $(this).data('algolia-queryid'),
                      objectIDs: [`${$(this).data('algolia-objectid')}`],
                      positions: [Number($(this).data('algolia-position'))],
                    };

                    window.aa('clickedObjectIDsAfterSearch', clickData);
                    saveForConversionTracking(clickData);
                });
              },
            }
        ]);

        theme.algoliaSearch.search.start();

        const _this = this
        this.$container.parent().find('.search-category').each(function() {
            $(this).on('click', _this.changeTab)
        });
        this.initialized = true;

        $('button.mobile-search-input-clear').on('click', function() {
            $('.mobile-search-input').val('').trigger('keyup');

            theme.algoliaSearch.search.helper.setQuery($(this).data('query')).search();
            $('.mobile-search-input').focus();
        });
    },

    show: function() {
        if (!this.initialized)
            this.init()
    },

    changeTab: function() {
        const category = $(this).attr('data-category')
        $(this).siblings().removeClass('active')
        $(this).addClass('active')
        $(this).closest('.mobile-search-content').find('.mobile-search-results').css("display", "none")
        $(`.mobile-search-results[data-category="${category}"]`).css("display", "block")
    }
}

theme.collectionComponent = {
    init: function() {
        const renderInfiniteHits = (renderOptions) => {
            const {
              hits,
              results,
              widgetParams,
              showMore,
              isLastPage,
            } = renderOptions;
    
            const nextButton = document.createElement('button');
            nextButton.className = 'next-button';
            nextButton.textContent = 'Load More...';
    
            nextButton.addEventListener('click', () => {
              showMore();
            });
    
            var hitsHTML = '<div class="product-grid">'
    
            hitsHTML += hits.map(hit => {
              var compareAtPriceElement = '' 
              var price = slate.Currency.formatMoney(hit.price * 100, theme.moneyFormat)
              var compareAtPrice = slate.Currency.formatMoney(hit.compare_at_price * 100, theme.moneyFormat)
              if (hit.compare_at_price > 0) compareAtPriceElement = `<div class="compare-at-price">${compareAtPrice}</div>`
              var productBadges = ''
              if (hit.tags.includes('new')) {
                productBadges = 
                  `<div class="product-badge"><span class="badge-arrow"></span>New</div>`
              }
    

            return `<div class="product-item" data-algolia-index="${results.index}" data-algolia-queryid="${hit.__queryID}" data-algolia-objectid="${hit.id}" data-algolia-position="${hit.__position}">
                <a href="/products/${hit.handle}?queryID=${hit.__queryID}">
                  ${productBadges}
                  <div class="product-image">
                    <img src="${hit.image}" />
                  </div>
                  <div class="product-description">
                    <div class="product-price ${hit.compare_at_price > 0 && 'discounted'}">
                      <div class="price">${price}</div>
                      ${compareAtPriceElement}
                    </div>
                    <div class="product-title">${hit.title} - ${hit.variant_title}</div>
                  </div>
                </a>
              </div>`
            }).join('')
    
            hitsHTML += '</div>'
    
            widgetParams.container.innerHTML = hitsHTML
            widgetParams.container.appendChild(nextButton);
    
            widgetParams.container.querySelector('.next-button').disabled = isLastPage;
        };
    
        const renderRefinementList = (renderOptions, isFirstRender) => {
        const {
            items,
            refine,
            createURL,
            widgetParams,
        } = renderOptions;

        const container = document.querySelector('#refinement-list');
        let attributeLabel = widgetParams.attribute
        if (attributeLabel.includes('.')) {
            attributeLabel = attributeLabel.split('.')
            attributeLabel = attributeLabel[attributeLabel.length - 1]
        }
        let listElement = null
        if (isFirstRender) {
            listElement = document.createElement('div')
            listElement.className = `refinement-list ${widgetParams.attribute}`
            container.appendChild(listElement)
        } else {
            listElement = document.getElementsByClassName(`refinement-list ${widgetParams.attribute}`).item(0)
        }

        const options = items.map(item =>
            `<div>
                <a href="${createURL(item.value)}"
                    data-value="${item.value}"
                    style="font-weight: ${item.isRefined ? 'bold' : ''}">
                    ${item.label} (${item.count})
                </a>
            </div>`
        ).join('');

        let menu = refinementMenus.filter(item => {
            if (item.attribute === widgetParams.attribute)
            return item
        })
        let { open } = menu[0]
        let listClass = `refinement-menu ${widgetParams.attribute}`
        let headingClass = "refinement-heading"
        if (open)
            headingClass += ' open'

        const list = 
            `<div class="${listClass}"> 
            <div class="${headingClass}" data-name="${widgetParams.attribute}">
                <div class="refinement-title">${attributeLabel}</div>
                <div class="refinement-icon">
                <div class="icon icon-plus">{% include 'icon-plus' %}</div>
                <div class="icon icon-minus">{% include 'icon-minus' %}</div>
                </div>
            </div>
            <div class="refinement-options" ${!open && 'style="display: none;"'}>
                ${options}
            </div>
            </div>`

        listElement.innerHTML = list

        listElement.querySelectorAll('a').forEach(element => {
            element.addEventListener('click', event => {
            event.preventDefault();
            refine(event.currentTarget.dataset.value);
            });
        });
        };
    
        const renderSortBy = (renderOptions, isFirstRender) => {
        const {
            options,
            currentRefinement,
            hasNoResults,
            refine,
            widgetParams,
        } = renderOptions;

        if (isFirstRender) {
            const select = document.createElement('select');
            const selectDropdown = document.createElement('div');
            selectDropdown.className = "sort-dropdown dropdown";

            $(select).on('change', function() {
            refine($(this).val());
            });

            widgetParams.container.appendChild(select);
            widgetParams.container.appendChild(selectDropdown);
        }

        const select = widgetParams.container.querySelector('select');
        const selectDropdown = widgetParams.container.querySelector('.sort-dropdown');

        select.disabled = hasNoResults;
        let currentRefinementLabel;
        currentRefinementLabel = options.find(e => e.value === currentRefinement)

        select.innerHTML = `
            ${options
            .map(
                option => `
                <option
                    value="${option.value}"
                    ${option.value === currentRefinement ? 'selected' : ''}>
                    ${option.label}
                </option>
                `
            )
            .join('')}
        `;

        selectDropdown.innerHTML = `
            <div class="dropdown-trigger">
            <span>${currentRefinementLabel.label}</span>
            {% include 'icon-arrow-down' %}
            </div>
            <div class="dropdown-menu" id="dropdown-menu" role="menu">
            <div class="dropdown-content">
                ${options.map(option => `
                <div data-value="${option.value}" 
                    class="dropdown-item ${option.value === currentRefinement ? 'is-active' : ''}">
                    ${option.label}
                </div>
                `).join('')}
            </div>
            </div>`
        };
    
        const createDataAttribtues = refinement =>
            Object.keys(refinement)
                .map(key => `data-${key}="${refinement[key]}"`)
                .join(' ');

        const renderListItem = item => `
        ${item.refinements
            .map(
            refinement =>
                `<div>
                <button ${createDataAttribtues(refinement)}>${refinement.label} <div class="icon icon-plus">{% include 'icon-close' %}</div></button>
                </div>`
            )
            .join('')}`; 

        const renderCurrentRefinements = (renderOptions, isFirstRender) => {
        const { items, refine, widgetParams } = renderOptions;

        let container = document.getElementById(widgetParams.container.substring(1))

        container.innerHTML = `${items.map(renderListItem).join('')}`;

        currentRefinementCountText = ''
        if (items.length > 0) {
            let fullItemCount = items.reduce(function(acc, item) {
            return acc + item.refinements.length
            }, 0)
            currentRefinementCountText = `(${fullItemCount})`
        }
        
        $('.filter-count').text(currentRefinementCountText)

        container.querySelectorAll('button').forEach(element => {
            element.addEventListener('click', event => {
                var item = {}
                var dataset = event.currentTarget.dataset
                for(let i = 0; i < Object.keys(dataset).length; i ++) {
                    var key = Object.keys(dataset)[i]
                    var val = Object.values(dataset)[i]
                    item[key] = val
                }

                refine(item);
            });
        });
        };
    
        const customInfiniteHits = instantsearch.connectors.connectInfiniteHits(
            renderInfiniteHits
        );
        const customRefinementList = instantsearch.connectors.connectRefinementList(
            renderRefinementList
        );
        const customCurrentRefinements = instantsearch.connectors.connectCurrentRefinements(
            renderCurrentRefinements
        );
        const customSortBy = instantsearch.connectors.connectSortBy(renderSortBy);

        theme.algoliaSearch.search.addWidgets([
            customInfiniteHits({
                container: document.querySelector('#collection-hits'),
                showPrevious: true,
            }),
            instantsearch.widgets.clearRefinements({
                container: '#clear-refinements',
                templates: {
                resetLabel: 'Clear All'
                }
            }),
        ]);

        let customRefinementLists = []

        if ($(window).width() < 989) {
            customRefinementLists.push(
                customSortBy({ 
                    container: document.querySelector('#mobile-sort-by'),
                    items: [
                    { label: 'Featured', value: 'shopify_products' },
                    { label: 'Price (asc)', value: 'shopify_products_price_asc' },
                    { label: 'Price (desc)', value: 'shopify_products_price_desc' },
                    { label: 'Ratings', value: 'shopify_products_ratings_desc' },
                    ],
                }),
                customCurrentRefinements({
                    container: '#mobile-current-refinements',
                }),
                instantsearch.widgets.stats({
                    container: '#mobile-stats'
                }),
            )
        } else {
            customRefinementLists.push(
                customSortBy({
                    container: document.querySelector('#sort-by'),
                    items: [
                    { label: 'Featured', value: 'shopify_products' },
                    { label: 'Price (asc)', value: 'shopify_products_price_asc' },
                    { label: 'Price (desc)', value: 'shopify_products_price_desc' },
                    { label: 'Ratings', value: 'shopify_products_ratings_desc' },
                    ],
                }),
                customCurrentRefinements({
                    container: '#current-refinements',
                }),
                instantsearch.widgets.stats({
                    container: '#stats'
                }),
            )
        }

        refinementMenus.forEach(item => {
            customRefinementLists.push(
                customRefinementList({
                    attribute: item.attribute,
                    open: item.open
                })
            )
        })
        theme.algoliaSearch.search.addWidgets(customRefinementLists)

        theme.algoliaSearch.search.start();
    }
}

theme.ProductFinder = {
    init: function(container) {
        this.$container = container

        let collectionHandle = window.location.pathname.split('/')
        collectionHandle = collectionHandle[collectionHandle.length - 1]
        collectionMap = window.productFinderDefaultMap
        if (window.productFinderMaps[collectionHandle])
            collectionMap = window.productFinderMaps[collectionHandle]

        this.currentQuestion = collectionMap
        this.questions = {}
        this.questions[0] = this.currentQuestion
        this.tabIndex = 0

        this.calculate()
        this.render()
    },

    hasNextQuestion: function(question, depthCount) {
        let { answers } = question
        if (depthCount > this.questionsDepth)
            this.questionsDepth = depthCount

        if (question.selectedAnswer) {
            let nextQuestion = null
            for (let i = 0; i < answers.length; i ++) {
                let answer = answers[i]
                if (question.selectedAnswer == answer.value && answer.next_question)
                    nextQuestion = answer.next_question
            }
            if (!nextQuestion && question.default)
                nextQuestion = question.default
            if (nextQuestion)
                this.hasNextQuestion(nextQuestion, depthCount + 1)
        } else {
            for (let i = 0; i < answers.length; i ++) {
                let answer = answers[i]
                if (answer.next_question)
                    this.hasNextQuestion(answer.next_question, depthCount + 1)
            }
            if (question.default) {
                this.hasNextQuestion(question.default, depthCount + 1)
            }
        }
    },

    calculate: function() {
        this.questionsDepth = 0
        this.activeTabIndex = 0
        for (let i = 0; i < Object.keys(this.questions).length; i ++) {
            var question = this.questions[i]
            if (this.currentQuestion === question) {
                this.activeTabIndex = i
                break
            }
        }
        this.hasNextQuestion(this.currentQuestion, 1)
        this.tabCount = this.activeTabIndex + this.questionsDepth
    },

    updateFilter: function() {
        let { questions } = this
        let productFinderOptions = {}
        for (let i = 0; i < Object.keys(questions).length; i ++) {
            let question = questions[i]
            if (question.selectedAnswer)
                productFinderOptions[question.facet] = question.selectedAnswer
        }
        $('.product-finder').trigger({type: 'optionsUpdated', productFinderOptions})
    },

    render: function() {
        this.$container.find('.question').html(this.currentQuestion.question)
        this.$container.find('.answer-label').html('')
        if (this.currentQuestion.selectedAnswer)
            this.$container.find('.answer-label').html(this.currentQuestion.selectedAnswer)
        
        this.$container.find('.answers').html('')
        var answers = this.currentQuestion.answers
        for (let i = 0; i < answers.length; i ++) {
            var answer = answers[i]
            var answerClass = "answer"
            if (this.currentQuestion.selectedAnswer === answer.value)
                answerClass += " active"
            let answerContent = answer.name
            if (answer.svg && window.svgMap[answer.svg])
                answerContent = `<img src="${window.svgMap[answer.svg]}">`
            this.$container.find('.answers').append(`<div class="${answerClass}" data-value="${answer.value}">${answerContent}</div>`)
        }
        $('.answers .answer').on('click', this.answerClicked.bind(this))

        var tabContainer = this.$container.find('.finder-tabs')
        tabContainer.html('')
        var tabStyle = ''
        var tabOverlap = 40;
        if ($(window).width() <= 768)
            tabOverlap = 20;
        var tabGap = tabOverlap / (this.tabCount - 1)
        var tabPercent = 100 / this.tabCount
        for (let i = 0; i < this.tabCount; i ++) {
            var question = this.questions[i]
            var tabLabel = ''
            var tabIndexData = ''
            var tabClass = "tab"
            if (this.tabIndex === i)
                tabClass += " active"
            var tabWidth = `calc(${tabPercent}% + ${tabOverlap}px)`
            var tabLeft = `calc(${tabPercent * i}% - ${tabGap * i}px)`
            var zIndex = (this.tabCount - 1) - Math.abs(i - this.tabIndex)
            if (question) {
                tabIndexData = `data-tab-index="${i}"`
                if (question.selectedAnswer)
                    tabLabel = question.selectedAnswer
                else
                    tabLabel = question.label
            }
            tabStyle = `style="width: ${tabWidth}; left: ${tabLeft}; z-index: ${zIndex};"`
            tabContainer.append(`<div class="${tabClass}" ${tabIndexData} ${tabStyle}>${tabLabel}</div>`)
        }
        tabContainer.find('.tab').on('click', this.tabClicked.bind(this))
    },

    answerClicked: function(e) {
        var element = e.target
        if (!$(element).hasClass('answer'))
            element = $(element).closest('.answer')
        var value = $(element).data('value')
        var { currentQuestion, questions } = this
        var { answers = [], selectedAnswer } = currentQuestion
        var previousAnswer = selectedAnswer;
        var nextQuestion = null;

        if (previousAnswer !== value) {
            for (let i = 0; i < answers.length; i ++) {
                var answer = answers[i]
                if (value == answer.value)
                    nextQuestion = answer.next_question
            }
            if (!nextQuestion && this.currentQuestion.default)
                nextQuestion = this.currentQuestion.default
            
            var questionIndex = null
            for (let i = 0; i < Object.keys(questions).length; i ++) {
                var question = questions[i]
                if (currentQuestion === question) {
                    questionIndex = i
                    break
                }
            }
            if (questionIndex === null) {
                questionIndex = Object.keys(questions).length
            } else {
                var excludedIndexs = Object.keys(questions)
                excludedIndexs = excludedIndexs.filter((idx) => idx > questionIndex)
                for (let i = 0; i < excludedIndexs.length; i ++) {
                    delete this.questions[excludedIndexs[i]].selectedAnswer
                    delete this.questions[excludedIndexs[i]]
                }
            }

            if (nextQuestion)
                this.questions[questionIndex + 1] = nextQuestion
            this.currentQuestion.selectedAnswer = value
            this.calculate()
            this.updateFilter()
            this.render()
        }
    },
    
    tabClicked: function(e) {
        var element = e.target
        tabIndex = $(element).data('tab-index')
        if (tabIndex !== undefined && Object.keys(this.questions).includes(tabIndex.toString())) {
            this.tabIndex = tabIndex
            this.currentQuestion = this.questions[tabIndex]
            this.render()
        }
    }
}

theme.analytics = {
    /**
     * Collect key/values from 
     * @return
     */
    productReportableAttributes: function (product, price, adjust_key_convention = false) {
        if (typeof product == 'undefined' || product == null) {
            return;
        }

        var namedTagFilter = [
            'Center Stone Shape',
            'Metal',
            'Metal Colour',
            'Stone Colour',
            'Style',
        ];

        var productAttributes = {
            'sku': product.sku,
            'category_id': theme.analytics.captureCategoryId(product, price),
        };

        if (typeof product.named_tags === 'object') {
            for (const index in product.named_tags) {
                namedTagFilter.forEach(function (filter) {
                    if (filter === index) {
                        attribute_key = index;

                        if (adjust_key_convention) {
                            attribute_key = attribute_key.replace(/([a-z0–9])([A-Z])/g, "$1_$2").toLowerCase().replaceAll(' ', '_').replace(/^_/, '')
                        }

                        productAttributes[attribute_key] = product.named_tags[index];
                    }
                });
            }
        }

        var tagFilter = [
            'Center Stone Shape:',
            'Metal:',
            'Metal Colour:',
            'Stone Colour:',
            'Style:',
            '_SubSubCategory|',
            '_catSubCategory|',
            '_SubCategory|',
            '_Category|',
            '_alt|',
        ];

        if (typeof product.tags === 'object') {
            product.tags.forEach(function (tag) {
                tagFilter.forEach(function (filter) {
                if (tag.startsWith(filter) && tag.replace(filter, '') !== '') {
                    attribute_key = filter.slice(0, -1);

                    if (adjust_key_convention) {
                        attribute_key = attribute_key.replace(/([a-z0–9])([A-Z])/g, "$1_$2").toLowerCase().replaceAll(' ', '_').replace(/^_/, '')
                    }

                    productAttributes[attribute_key] = tag.replace(filter, '');
                }
                });
            });
        }

        return productAttributes;
    },

    captureCategory: function (product, price) {
        // Gifts
        if (price < 400) {
            return 'Gifts';
        }

        // Engagement Rings
        if (typeof product.tags === 'object') {
            if (product.tags.includes('_catSubCategory|RINGSHALO')
                || product.tags.includes('_catSubCategory|RINGSSHOULD')
                || product.tags.includes('_catSubCategory|RINGS3STONE')
                || product.tags.includes('_catSubCategory|RINGSSOLIT')) {
                return 'Engagement & Wedding';
            }
        }

        // Jewellery
        return 'Jewellery';
    },

    captureCategoryId: function (product, price) {
        // Gifts
        if (price < 400) {
            return 3;
        }

        // Engagement Rings
        if (typeof product.tags === 'object') {
            if (product.tags.includes('_catSubCategory|RINGSHALO')
                || product.tags.includes('_catSubCategory|RINGSSHOULD')
                || product.tags.includes('_catSubCategory|RINGS3STONE')
                || product.tags.includes('_catSubCategory|RINGSSOLIT')) {
                return 1;
            }
        }

        // Jewellery
        return 2;
    },

    enrichedCartAction: function (data_layer_action)
    {
        if (data_layer_action === null) {
            return;
        }

        var ecommerceItems = [];

        theme.cart.data.items.forEach(function (item) {
            ecommerceItems.push({
                item_id: item.id,
                item_name: item.title,
                price: (item.price / 100).toFixed(2),
                quantity: item.quantity,
            });
        });

        dataLayer.push({
            event: data_layer_action,
            ecommerce: {
                value: (theme.cart.data.total_price / 100).toFixed(2),
                currency: window.Shopify.currency.active,
                items: ecommerceItems
            }
        });
    },

    enrichedAction: function (productData, actionType) {
        if (actionType === null) {
            return;
        }

        getProductData(`{
          productByHandle(handle: "${productData.handle}") {
            ${queryProductFragment}
          }
        }`).then((response) => {
            if (typeof response.errors === 'object') {
                return;
            }

            dataLayer.push({ ecommerce: null });

            dataLayer.push({
              event: actionType,
              ecommerce: {
                value: (productData.price / 100).toFixed(2) * productData.quantity,
                currency: window.Shopify.currency.active,
                items: [{
                    id: productData.id,
                    item_name: productData.title,
                    item_id: productData.id,
                    price: (productData.price / 100).toFixed(2),
                    quantity: productData.quantity,
                    currency: window.Shopify.currency.active,
                    total_amount:  (productData.price / 100).toFixed(2) * productData.quantity,
                    item_category: theme.analytics.captureCategory(response.data.productByHandle, productData.price / 100),
                    attributes: theme.analytics.productReportableAttributes(response.data.productByHandle, productData.price / 100, true),
                }]
              }
            });
        });
    },
}

theme.cart = {
    /*
     * Public vars
     */
    isShowing: false,
    data: {},
    currentAjaxRequest: null,
    currentTimeout: null,


    /**
     * The initialising code
     */
    init: function () {
        // Reference to this
        var self = this;

        // Cache some DOM elements
        this.cartCount = document.querySelector('.cart-count');
        this.cart = document.querySelector('.cart--drawer');
        this.header = this.cart.querySelector('.cart__header');
        this.btnClose = this.cart.querySelector('.cart__close');
        this.btnCheckout = this.cart.querySelector('.cart__checkout');
        this.trigger = null;
        this.count = this.cart.querySelector('.cart__count');
        this.content = this.cart.querySelector('.cart__content');
        this.footer = this.cart.querySelector('.cart__footer');
        this.subtotal = this.cart.querySelector('.cart__subtotal');

        // Build a loader element for later use
        this.loader = document.createElement('div');
        this.loader.className = 'loader';

        // Check if we're on a cart page
        var isCartPage = document.body.classList.contains('template-cart');

        if (isCartPage) {
            // this.addItemListeners();
            theme.change_size.init();

            this.btnCheckout.addEventListener('click', this.clickCheckout.bind(this));
        }
        else {
            // Initialise ajax cart
            theme.cart.updateCartItems(function () {
                theme.cart_slider.init();
                theme.change_size.init();
            });

            // Add listeners to buttons
            var buttonOpen = document.querySelector('.header__btn--cart');
            if (buttonOpen) {
                buttonOpen.addEventListener('click', this.toggleCartDrawer.bind(this));
            }

            this.btnClose.addEventListener('click', function () {
                self.closeCartDrawer();
            });

            var fade = document.querySelector('.fade');
            fade.addEventListener('click', this.closeCartDrawer.bind(this));

            this.btnCheckout.addEventListener('click', this.clickCheckout.bind(this));
        }

        this.fetchData(function () {
        });
    },


    /**
     * Updates the data property with data from cart.js
     */
    fetchData: function (callback) {
        var self = this;
        Shopify.getCart( function (data) {
            self.data = data;


            if (callback) callback();
        });
    },


    /**
     * Send data to /cart/change.js
     */
    changeData: function (data, callback) {
        var self = this;

        $.ajax({
            type: 'post',
            url: '/cart/change.js',
            data: data,
            dataType: 'json',
            complete: function (jqxhr, status) {
                self.fetchData(function () {
                    self.updateBadges();
                    self.updateSubtotal();
                    $(document).trigger('cart:change');
                    if (self.populateFreeGift)
                        self.populateFreeGift(); 
                });
                if (callback) callback(jqxhr, status);
            }
        });
    },

    /**
     * Promise to send data to /cart/change.js
     */
    changeDataPromise: function(data) {
        return new Promise((resolve, reject) => {
            $.ajax({
                type: 'post',
                url: '/cart/change.js',
                data: data,
                dataType: 'json',
                complete: function (jqxhr, status) {
                    var { responseJSON: { items } } = jqxhr
                    if (data.quantity > 0) {
                        var item = items[data.line - 1]
                        if (item.quantity == data.quantity) {
                            resolve(jqxhr, status)
                        }
                        else {
                            reject(data.quantity - item.quantity)
                        }
                    } else {
                        resolve(jqxhr, status)
                    }
                }
            });
        })
    },


    /**
     * Updates the header's cart badge number by the amount passed
     */
    updateBadges: function () {

        if (this.data.item_count === 0) {
            $(theme.cart.cartCount).hide();
        } else {
            $(theme.cart.cartCount).show();
        }
        theme.cart.cartCount.innerHTML = theme.cart.count.innerHTML = this.data.item_count;
    },


    /**
     * Get's cart html from src/templates/cart.drawer.liquid
     */
    updateCartItems: function (callback) {
        var self = this;

        $.get('/cart/?view=drawer', function (data) {
            self.content.innerHTML = data;
            self.addItemListeners();

            if (callback) callback();
            $('body').trigger('ajaxCart.afterCartLoad');

            // Slide toggle slider section
            $('#CartSpecialInstructions').css('display', 'none');
            $('#cart-notes').click(function () {
                $('#CartSpecialInstructions').slideToggle();
            });
        });
    },


    /**
     * Get's cart html from src/templates/cart.drawer.liquid
     */
    updateCartItemsPromise: function () {
        var self = this;

        return new Promise((resolve) => {
            $.get('/cart/?view=drawer', function (data) {
                self.content.innerHTML = data;
                self.addItemListeners();
                $('body').trigger('ajaxCart.afterCartLoad');
    
                // Slide toggle slider section
                $('#CartSpecialInstructions').css('display', 'none');
                $('#cart-notes').click(function () {
                    $('#CartSpecialInstructions').slideToggle();
                });
                resolve();
            });
        })
    },


    /**
     * Updates the subtotal
     */
    updateSubtotal: function () {
        this.subtotal.innerHTML = slate.Currency.formatMoney(this.data.total_price, theme.moneyFormat);
        $('body').trigger('ajaxCart.afterCartLoad');
        var splitPrice = (this.data.total_price / 4);
        $('#total-split').html(slate.Currency.formatMoney(splitPrice, theme.moneyFormat));
    },


    /**
     * Updates the cart
     */
    fetchUpdatedCart: function() {
        var self = this
        this.fetchData(function () {
            self.updateBadges();
            self.updateSubtotal();
            self.updateCartItems();
        });
    },


    /**
     * User clicks the checkout button.
     */
    clickCheckout: function (e) {
        if (theme.cart.data.item_count === 0) {
            return;
        }

        theme.analytics.enrichedCartAction('begin_checkout');
    },


    /**
     * Call's appropriate method depending on cart state
     */
    toggleCartDrawer: function (e) {
        e.preventDefault();

        if (this.isShowing) {
            this.closeCartDrawer();
        }
        else {
            this.openCartDrawer();
        }
    },


    /**
     * Add class to body so we can animate the cart drawer to the open position
     */
    openCartDrawer: function () {

        document.body.classList.add('cart-showing');
        this.isShowing = true;

        // Capture the element that opened the cart
        this.trigger = document.activeElement;
        this.btnClose.focus();
    },


    /**
     * Removes above body class so we can animate the cart drawer to the closed position
     */
    closeCartDrawer: function () {
        document.body.classList.remove('cart-showing');
        this.isShowing = false;

        // Throw the focus back to the element that opened the cart
        if (this.trigger) {
            this.trigger.focus();
            this.trigger = null;
        }
        // Refresh the cart incase someone changes a quantity without updating
        // this.updateCartItems();
    },


    /**
     * Add event listeners to cart items (eg. buttons, inputs)
     */
    addItemListeners: function () {
        var self = this;
        var cartItems = document.querySelectorAll('.cart-item');

        cartItems.forEach(function (el) {
            el.querySelector('.quantity__control--dropdown').addEventListener('change', self.quantityChangeHandler.bind(self));
            el.querySelector('.quantity__control--remove').addEventListener('click', self.removeClickHandler.bind(self));
        });
    },

    quantityChangeHandler: function(e) {
        e.preventDefault();

        if(!this.updatingItemQuantity) {
            var self = this;

            var target = e.currentTarget;
            // Exit if disabled
            if (target.classList.contains('quantity__control--disabled')) return;
            $('.cart .cart-item .quantity__control').addClass('disabled');
            self.updatingItemQuantity = true

            // TODO: let user know if item is last of stock

            var cartItem = target.parents('.cart-item');

            // update the line item quantity
            var line = Number(target.dataset.line);
            var quantity = $(target).val();

            this.data.items[line].quantity = quantity;

            // update the badge counts
            this.data.item_count += 1;
            this.updateBadges();

            // Update subtotal
            this.data.total_price += this.data.items[line].price;
            this.updateSubtotal();

            // debounce the ajax call
            this.currentTimeout = setTimeout(function () {
                var startingChain = JSON.stringify(self.currentTimeout)
                self.changeDataPromise({ 
                    quantity: quantity,
                    line: (line + 1)
                }).then(() => {
                    if (startingChain == JSON.stringify(self.currentTimeout)) {
                        self.fetchData(function () {
                            self.updateBadges();
                            self.updateSubtotal();
                            self.updateCartItemsPromise().then(() => {
                                $('.cart .cart-item .quantity__control').removeClass('disabled');
                                clearTimeout(self.currentTimeout);
                                $(document).trigger('cart:change');
                                if (self.populateFreeGift)
                                    self.populateFreeGift(); 
                                self.updatingItemQuantity = false
                            });
                        });
                    }
                })
    
            }, 500);

            theme.analytics.enrichedAction(this.data.items[line], 'add_to_cart');
        }
    },

    removeClickHandler: function (e) {
        e.preventDefault();

        if(!this.updatingItemQuantity) {
            var self = this;

            var target = e.currentTarget;
            // Exit if disabled
            if (target.classList.contains('quantity__control--disabled')) return;
            $('.cart .cart-item .quantity__control').addClass('disabled');
            self.updatingItemQuantity = true

            // TODO: let user know if item is last of stock

            var cartItem = target.parents('.cart-item');

            // update the line item quantity
            var line = Number(target.dataset.line);

            var oldQuantity = this.data.items[line].quantity;
            var quantity = 0;

            this.data.items[line].quantity = quantity;
            $(cartItem).addClass('hidden')

            // update the badge counts
            this.data.item_count -= oldQuantity;
            this.updateBadges();

            // Update subtotal
            this.data.total_price += this.data.items[line].price;
            this.updateSubtotal();

            // debounce the ajax call
            this.currentTimeout = setTimeout(function () {
                var startingChain = JSON.stringify(self.currentTimeout)
                self.changeDataPromise({ 
                    quantity: quantity,
                    line: (line + 1)
                }).then(() => {
                    if (startingChain == JSON.stringify(self.currentTimeout)) {
                        self.fetchData(function () {
                            self.updateBadges();
                            self.updateSubtotal();
                            self.updateCartItemsPromise().then(() => {
                                $('.cart .cart-item .quantity__control').removeClass('disabled');
                                clearTimeout(self.currentTimeout);
                                $(document).trigger('cart:change');
                                if (self.populateFreeGift)
                                    self.populateFreeGift(); 
                                self.updatingItemQuantity = false
                            });
                        });
                    }
                })
    
            }, 500);

            theme.analytics.enrichedAction(this.data.items[line], 'remove_from_cart');
        }
    }
};

theme.Accordion = (function () {


    /**
     * Constructor
     */
    function Accordion(container) {
        // Public vars
        this.container = container;
        this.showingId;
        // Reference to self for use in closures
        var self = this;

        // Add click listeners to each button
        var buttons = container.querySelectorAll('.panel__heading button');
        buttons.forEach(function (el) {
            el.addEventListener('click', self.toggleBody.bind(self));
        });

    }

    /**
     * Event handler - decides what to show or hide
     */
    Accordion.prototype.toggleBody = function (e) {

        var bodyId = e.target.dataset.toggle;
        var body = this.container.querySelector('#' + bodyId);

        // Is something showing?
        if (this.showingId) {
            // Is that something showing the same as what got clicked?
            if (this.showingId === bodyId) {
                this.hideBody(body);
            }
            else {
                var showingBody = this.container.querySelector('#' + this.showingId);
                this.hideBody(showingBody);
                this.showBody(body);
            }
        }
        else {
            this.showBody(body);
        }
    },

        /**
         * Event handler - shows a panel body
         */
        Accordion.prototype.showBody = function (body) {
            body.parents('.panel').classList.remove('collapsed');
            this.showingId = body.id;
        },

        /**
         * Event handler - hides a panel body
         */
        Accordion.prototype.hideBody = function (body) {
            body.parents('.panel').classList.add('collapsed');
            this.showingId = null;
        };

    return Accordion;

}());

theme.collectionFilter = {
    init: function () {

        function closeCollectionFilters() {
            $(".snize-product-filters-title").removeClass("open");
            $(".snize-product-filters-list").css("display", "none");
        }

        setTimeout(closeCollectionFilters, 1000);
    }
};

theme.ip_data = {

    init: function () {
        // Send request to ipdata to check address
        $.get("https://api.ipdata.co", function (response) {

            // Parse JSON
            JSON.stringify(response, null, 4);

            // Build and check country info
            var ausCode = "AU",
                usCode = "US",
                countryCode = response.country_code;
        }, "jsonp");
    }
}

theme.cart_slider = {

    init: function () {

        $('.cart__slick--wrapper').each(function () {
            var $this = $(this),
                cartSlider = $this.find('.cart__slick'),
                prevArrow = $this.find('.prev'),
                nextArrow = $this.find('.next');

            // Initialise Slick
            if (!cartSlider.hasClass('slick-initialized')) {
                cartSlider.slick({
                    slidesToShow: 3,
                    dots: false,
                    arrows: false,
                    responsive: [
                        {
                            breakpoint: 500,
                            settings: {
                                slidesToShow: 2,
                            }
                        }
                    ]
                });

                // Bind arrows to slider
                $(prevArrow).click(function () {
                    $(cartSlider).slick('slickPrev');
                });
                $(nextArrow).click(function () {
                    $(cartSlider).slick('slickNext');
                });
            }
        });

        $('.cart__heading').click(function () {
            var $selectSvg = $(this).children('h4').children('svg'),
                $selectWrapper = $(this).parent('.cart__upsell').children('.cart__slick--wrapper');

            $selectWrapper.slideToggle();

            if ($selectSvg.hasClass('rotate')) {
                $selectSvg.removeClass('rotate');
            } else {
                $selectSvg.addClass('rotate');
            }
        });
    }
};

theme.scroller = {
    /*
    // On click of arrow, scrolls to top
    */
    scrollFire: function () {

        const scrollButton = $('.scroll-top');
        const scrollBind = $('html, body');

        $(scrollButton).click(function () {
            $(scrollBind).animate({scrollTop: 0});
        });
    }
};

// =require modules/collection-filter.js
theme.Video = (function () {

    function Video(container) {
        var iframe = container.querySelector('iframe');
        this.player = new Vimeo.Player(iframe);

        var wrapper = container.querySelector('.section__video');
        if (wrapper) {
            wrapper.addEventListener('click', this.wrapperClickHandler.bind(this));
        }
    }

    Video.prototype = $.extend({}, Video.prototype, {

        wrapperClickHandler: function (e) {
            e.currentTarget.classList.add('section__video--played');
            this.player.play();
        }
    });

    return Video;
})();

theme.change_size = {

    init: function () {

        $('.size-change').change(function () {
            var changeValue = $(this).val();
            $.post('/cart/change.js', {
                quantity: 1,
                line: 1,
                properties: {
                    Size: changeValue
                }
            }).done(function () {
                theme.cart.updateCartItems();
            });
        });
    }
};


/*================ Templates ================*/
/**
 * Customer Addresses Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Customer Addresses
 * template.
 *
 * @namespace customerAddresses
 */

theme.customerAddresses = (function () {
    $(function () {
        var $newAddressForm = $('#AddressNewForm');

        if (!$newAddressForm.length) {
            return;
        }

        // Initialize observers on address selectors, defined in shopify_common.js
        if (Shopify) {
            new Shopify.CountryProvinceSelector('AddressCountryNew', 'AddressProvinceNew', {
                hideElement: 'AddressProvinceContainerNew'
            });
        }

        // Initialize each edit form's country/province selector
        $('.address-country-option').each(function () {
            var formId = $(this).data('form-id');
            var countrySelector = 'AddressCountry_' + formId;
            var provinceSelector = 'AddressProvince_' + formId;
            var containerSelector = 'AddressProvinceContainer_' + formId;

            new Shopify.CountryProvinceSelector(countrySelector, provinceSelector, {
                hideElement: containerSelector
            });
        });

        // Toggle new/edit address forms
        $('.address-new-toggle').on('click', function () {
            $newAddressForm.toggleClass('hide');
        });

        $('.address-edit-toggle').on('click', function () {
            var formId = $(this).data('form-id');
            $('#EditAddress_' + formId).toggleClass('hide');
        });

        $('.address-delete').on('click', function () {
            var $el = $(this);
            var formId = $el.data('form-id');
            var confirmMessage = $el.data('confirm-message');
            if (confirm(confirmMessage || 'Are you sure you wish to delete this address?')) {
                Shopify.postLink('/account/addresses/' + formId, {parameters: {_method: 'delete'}});
            }
        });
    });
})();

/**
 * Password Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Password template.
 *
 * @namespace password
 */

theme.customerLogin = (function () {
    $(function () {
        var config = {
            recoverPasswordForm: '#RecoverPassword',
            hideRecoverPasswordLink: '#HideRecoverPasswordLink'
        };

        if ($(config.recoverPasswordForm).length === 0) {
            return;
        }

        checkUrlHash();
        resetPasswordSuccess();

        $(config.recoverPasswordForm).on('click', onShowHidePasswordForm);
        $(config.hideRecoverPasswordLink).on('click', onShowHidePasswordForm);

        function onShowHidePasswordForm(evt) {
            evt.preventDefault();
            toggleRecoverPasswordForm();
        }

        function checkUrlHash() {
            var hash = window.location.hash;

            // Allow deep linking to recover password form
            if (hash === '#recover') {
                toggleRecoverPasswordForm();
            }
        }

        /**
         *  Show/Hide recover password form
         */
        function toggleRecoverPasswordForm() {
            $('#RecoverPasswordForm').toggleClass('hide');
            $('#CustomerLoginForm').toggleClass('hide');
        }

        /**
         *  Show reset password success message
         */
        function resetPasswordSuccess() {
            var $formState = $('.reset-password-success');

            // check if reset password form was successfully submited.
            if (!$formState.length) {
                return;
            }

            // show success message
            $('#ResetSuccess').removeClass('hide');
        }
    });
})();


$(document).ready(function () {
    var sections = new slate.Sections();
    sections.register('product', theme.Product);
    sections.register('hero-slider', theme.HeroSlider);
    sections.register('testimonials', theme.HeroSlider);

    // Common a11y fixes
    slate.a11y.pageLinkFocus($(window.location.hash));

    $('.in-page-link').on('click', function (evt) {
        slate.a11y.pageLinkFocus($(evt.currentTarget.hash));
    });

    // Wrap videos in div to force responsive layout.
    slate.rte.wrapTable();
    slate.rte.iframeReset();

    // Apply a specific class to the html element for browser support of cookies.
    if (slate.cart.cookiesEnabled()) {
        document.documentElement.className = document.documentElement.className.replace('supports-no-cookies', 'supports-cookies');
    }

    if (theme.template && theme.template.hasHeader) {
        theme.header.init();
        theme.searchModal();
    }
    if (theme.template && theme.template.hasCart) {
        theme.cart.init();
    }
    if (theme.settings.scroll_switch === true) {
        theme.scroller.scrollFire();
    }

    theme.algoliaSearch.init();

    if (theme.template && theme.template.page == 'search') {
        theme.searchDropdown.init();
        theme.searchDropdown.disableClose();
    }
    
    // if (theme.template && theme.template.page == 'collection') {
    //     var productFinderElement = $('#collection-product-finder')
    //     theme.ProductFinder.init(productFinderElement);
    // }

    theme.footerAccordion.init();

    theme.featuredCollectionSlider.init();

    theme.featuredArticleSlider.init();

    theme.productBtnBackTo.init();

    theme.productAccordion.init();

    theme.Accordian.init();

    theme.collectionFilter.init();

    // Accordions
    document.querySelectorAll('.accordion').forEach(function (el) {
        new theme.Accordion(el);
    });

    // theme.ip_data.init();

    theme.sections = sections

    //Sticky add to cart block feature
    if ($('.product-form-wrapper').length && $(window).width() < 768) {
        var $form = $('.product .product__form');
        $(window).on('scroll', function () {
            var topVal = $('.product .product__form').offset().top + $('.product .product__form').outerHeight(),
                backwardTopVal = $('.payment__splitter').offset().top + $('.payment__splitter').height(),
                windodOffsetPlus = window.pageYOffset + window.innerHeight;

            if (!$form.hasClass('fixed') && windodOffsetPlus >= topVal) {
                // $form.addClass('fixed');
            } else if ($form.hasClass('fixed') && (windodOffsetPlus - $form.outerHeight()) < backwardTopVal) {
                //$form.removeClass('fixed');
            }
        });
    }

    if ($(window).width() < 768) {
        $(document).on('click', '.snize-product-filters-header', function(e) {
            e.preventDefault();
            $(this).toggleClass('open-tab');
            $(this).next().toggleClass('filter-show');
        })

        $(document).on('click', '.snize-mobile-filter-header-sort', function() {
            if ($('.snize-mobile-filter-header-filter').hasClass('filter-close')) {
                $('.snize-mobile-filter-header-filter').removeClass('filter-close selected')
                $('.snize-modal .snize-close-button').trigger('click');
            }

            if (!$('.snize-mobile-filter-header-filter').hasClass('filter-close')) {
                $('.snize-mobile-container-content').removeClass('active')
            }
        })
        
        /**
         * Sticky add to cart button.
         */
        let addToCart = document.querySelector('[data-add-to-cart]');
        let addToCartHasBeenSeen = false;
        let addToCartObserver = new IntersectionObserver((entries, observer) => { 
        entries.forEach(entry => {
            if (entry.intersectionRatio != 1 && addToCartHasBeenSeen) {
                $('.back-to-add-to-cart').addClass('shown');
                $('#reamaze-widget').css({'bottom': '70px'});
            }
            else {
                addToCartHasBeenSeen = true;
                $('.back-to-add-to-cart').removeClass('shown');
                $('#reamaze-widget').css({'bottom': '22px'});
            }
        });
        }, {threshold: 1});

        if (addToCart) {
            addToCartObserver.observe(addToCart);
        }

        $(document).on('click', '.back-to-add-to-cart', function() {
            $("body,html").animate(
                {
                    scrollTop: $("[data-add-to-cart]").offset().top - ($(window).height() - 60)
                },
                800 //speed
            );
        })

        /**
         * Sticky product information.
         */
        let productSidebarMarker = document.querySelector('.product__container_marker');
        let productSidebarMarkerObserver = new IntersectionObserver((entries, observer) => { 
        entries.forEach(entry => {
            if (entry.intersectionRatio != 1 && $(document).scrollTop() > 300) {
                $('.product-form-wrapper').addClass('fixed');
                $('.product__container').addClass('fixed');
            } else {
                $('.product-form-wrapper').removeClass('fixed');
                $('.product__container').removeClass('fixed');
            }
        });
        }, {rootMargin: '-140px', threshold: 1});

        if (productSidebarMarker) {
            productSidebarMarkerObserver.observe(productSidebarMarker);
        }

        /**
         * Sticky collection filters.
         */
        let mobileFilters = document.querySelector('.mobile-buttons')
        let mobileFilterPosition = document.querySelector('#mobile-filter-position')

        // check below
        let mobileFiltersObserver = new IntersectionObserver((entries, observer) => {
            entries.forEach(entry => {
                if (entry.intersectionRatio != 1 && $('#collection-hits').hasClass('collection-in-view')) {
                    $(mobileFilterPosition).addClass('filter-fixed')
                    $(mobileFilters).addClass('fixed')
                } else {
                    $(mobileFilterPosition).removeClass('filter-fixed')
                    $(mobileFilters).removeClass('fixed')
                }
            })
        }, {rootMargin: '-114px', threshold: 1});
        if (mobileFilters)
            mobileFiltersObserver.observe(mobileFilterPosition)

        let collectionHitsObserver = new IntersectionObserver((entries, observer) => {
            entries.forEach(entry => {
                if (entry.intersectionRatio > 0) {
                    $('#collection-hits').addClass('collection-in-view');
                } else {
                    $('#collection-hits').removeClass('collection-in-view');
                    $(mobileFilterPosition).removeClass('filter-fixed')
                    $(mobileFilters).removeClass('fixed')
                }
            });
        });

        var collectionHitsContainer = document.querySelector('#collection-hits');
        
        if (collectionHitsContainer != null) {
            collectionHitsObserver.observe(collectionHitsContainer);
        }
    }

    $('.js-login-modal a').on('click', function(e) {
        e.preventDefault();
        $('.modal-login').addClass('is-show')
    })

    $('.modal-login-close, .modal-login').on('click', function(e) {
        $('.modal-login').removeClass('is-show')
    })

    $('.modal-login__wrap').on('click', function(e) {
        e.stopPropagation();
    })

    $('.hidden-overflow,.showing-overflow').on('click', function () {
        if ($(this).hasClass('showing-overflow')) {
            $(this).addClass('hidden-overflow');
            $(this).removeClass('showing-overflow');

            return;
        }

        $(this).addClass('showing-overflow');
        $(this).removeClass('hidden-overflow');

    });

    $(document).on('focus', '.search__form.desktop-only #Search', function() {
        theme.searchDropdown.show()
    })

    $(document).on('click', '.header__btn--search-desktop', function() {
        theme.searchDropdown.show()
    })
    
    /*
    if (theme.template && theme.template.page == 'product') {
      setTimeout(function () {
        $('[data-single-option-selector]').trigger('change');
      }, 1500);
    }
    */

    document.addEventListener("keydown", function(event) {
        if (event.key === "Escape") {
            theme.searchDropdown.hide();
            document.body.classList.remove('menu-expanded', 'search-expanded');
        }
    });

    $('.cart__slick').slick({
      centerMode: true,
      centerPadding: '10px',
      slidesToShow: 1,
      arrows: false,
      dots: true,
      infinite: true,
    //   autoplay: true,
      autoplaySpeed: 5000,
    });

    $('.cart__promotions .cart__accordian').each(function(element) {
        if (! $(this).hasClass('hidden')) {
            $(this).addClass('open')
            $(this).find('.cart__accordian-content').slideDown()
            return false
        }
    })

    $('.cart__accordian-title').on('click', function() {
      var accordian = $(this).parent()
      let open = accordian.hasClass('open')
      let container = $(this).parent().parent()
      
      if (!open) {
        accordian.siblings().find('.cart__accordian-content').slideUp()
        accordian.siblings().removeClass('open')
        $(this).next().slideDown().addClass('open')
        accordian.addClass('open')
        accordian.find('.cart__slick').slick('refresh')
      } else {
        $(this).next().slideUp()
        accordian.removeClass('open')
      }
    })

    $(document).on('click', '.modal .step-button', function() {
        var step = $(this).attr('data-step')
        if (step) {
            $('.step-chooser').addClass('step-choosen')
            $(`.step-${step}`).addClass('shown')
            $(`.step-${step} .slider`).slick('refresh')
        } else {
            $(this).html('<div class="loading-spinner"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>')
        }
    })

    $(document).on('click', '.header__btn--search', function() {
        $('.mobile-only .header__search').slideToggle()
    });

    $(document).on('click', 'button.toggle-modal', function() {
        $(`.${$(this).data('modal-name')}`).trigger('before:shown');
        $(`.${$(this).data('modal-name')}`).addClass('shown');
        $('body').addClass('modal-shown');
        $(`.${$(this).data('modal-name')}`).trigger('after:shown');
    });

    // Check for a click outside the modal
    $(document).on('click', '.modal', function() {
        $('.step-chooser').removeClass('step-choosen')
        $('.step-1').removeClass('shown')
        $('.step-2').removeClass('shown')
        $('.step-3').removeClass('shown')
        $(this).removeClass('shown')
        $('body').removeClass('modal-shown')
    })

    $(document).on('click', '.modal-inner', function(event) {
        event.stopPropagation();
    })

    $(document).on('click', '.modal .close-button', function() {
        $(this).closest('.modal').removeClass('shown')
        $('body').removeClass('modal-shown')
    })

    $(document).on('click', '.modal .back-button', function() {
        if ($('.modal .tabbed-content .step-slick').hasClass('shown')) {
            $('.modal .tabbed-content .step-slick.shown').removeClass('shown')
            $('.modal .tabbed-content .tab.slider-shown').removeClass('slider-shown')
        } else if($('.step-chooser.step-choosen')) {
            $('.step-chooser').removeClass('step-choosen')
            $('.step').removeClass('shown')
        } else {
            $(this).closest('.modal').find('.step').removeClass('shown')
            $(this).closest('.modal').find('.step-chooser').removeClass('step-choosen')
        }
    })

    $(document).on('click', '.modal .size-chart-btn', function() {
        $('.tabs .tab').removeClass('active')
        $(`.tabs .tab[data-tab="size-chart"]`).addClass('active')
        $('.tabbed-content .tab').removeClass('shown')
        $(`.tabbed-content .tab.size-chart`).addClass('shown')
        $(`.tabbed-content .tab.size-chart .slider`).slick('refresh')
    })

    $(document).on('click', '.modal .tab-button', function() {
        var tab = $(this).data('tab')
        $('.step-chooser').addClass('step-choosen')
        $('.step').addClass('shown')
        $('.tabs .tab').removeClass('active')
        $(`.tabs .tab[data-tab="${tab}"]`).addClass('active')
        $('.tabbed-content .tab').removeClass('shown')
        $(`.tabbed-content .tab.${tab}`).addClass('shown')
        $(`.tabbed-content .tab.${tab} .slider`).slick('refresh')
    })

    $(document).on('click', '.modal .tabs .tab', function() {
        var tab = $(this).data('tab')
        $(this).siblings().removeClass('active')
        $(this).addClass('active')

        $('.tabbed-content .tab').removeClass('shown')
        $(`.tabbed-content .tab.${tab}`).addClass('shown')
        $(`.tabbed-content .tab.${tab} .slider`).slick('refresh')
    })

    $(document).on('click', '.slider-btn', function() {
        var sliderName = $(this).data('slider')
        var tab = $(this).closest('.tab')
        tab.addClass('slider-shown')
        tab.find(`.step-slick.${sliderName}`).addClass('shown')
        tab.find(`.step-slick.${sliderName}`).slick('refresh')
    })

    $(document).on('click', '.size-finder-add-to-cart', function() {
        var button = $(this)
        var variantId = $(this).attr('data-variant-id')
        if (! button.hasClass('disabled')) {
            button.addClass('disabled')
            CartJS.addItem(variantId, 1, {}, {
                "success": function(data, textStatus, jqXHR) {
                    setTimeout(function () {
                        theme.cart.fetchData(function () {
                            theme.cart.updateCartItems(function() {
                                theme.cart.updateBadges();
                                theme.cart.updateSubtotal();
                                theme.cart.openCartDrawer();
                                $(document).trigger('cart:change');
                                button.removeClass('disabled')
                                button.closest('.modal').removeClass('shown')
                            });
                        });
                    }, 150)
                }
            });
        }
    })

    $('.step-slick').slick({
        slidesToShow: 1,
        infinite: false,
        dots: true,
        // arrows: true,
        arrows: false,
        adaptiveHeight: false
    });

});

var links = document.links;
for (let i = 0, linksLength = links.length; i < linksLength; i++) {
    if (links[i].hostname !== window.location.hostname) {
        links[i].target = '_blank';
        links[i].rel = 'noopener noreferrer';
    }
}